<template>
	<div>
		<div id="messageManageBox">

			<div class="container">
				<!-- #409EFF -->
				<div class="headerContainer message-page-header" style="align-items: baseline;" v-if="isAlreadyCommunicated==0">
					<div @click="changeType(0)" class="message-page-tab"
						:class="{'is-active': isResumeDatabase==0}">
						<div class="title" style="cursor: pointer;" >消息管理
						</div>
                        <!--  -->
						<div class="message-page-tab-indicator">
						</div>
					</div>
					<!-- <div class="message-page-tab"
						:class="{'is-active': isResumeDatabase==1}">
                    	<div class="title" style="cursor: pointer;" @click="changeType(1)">简历库
                    	</div>
						<div class="message-page-tab-indicator">
                    	</div>
                    </div>
                   <div v-if="isResumeDatabase==1" style="margin-left:-24px" class="message-page-tab"
                    	:class="{'is-active': isResumeDatabase==1}">
                    	<div class="title" style="cursor: pointer;" @click="changeType(1)">（{{num1}}）
                        </span>
                    	</div>
                    
                    </div> -->
					<!-- <div v-if="isResumeDatabase==1" class="resume-page-refresh" :class="{'is-refreshing': resumeRefreshing}" @click="refreshResumePage">
						刷新 <i class="el-icon-refresh"></i>
					</div> -->
                    <div class="flex1">
                        
                    </div>
                     <el-button v-if="isResumeDatabase==0 && hasLogin" style="width: 88px;" type="primary" icon="el-icon-search" @click="toMessageSearch">搜索</el-button>


				</div>
				<div class="headerContainer" v-else-if="isAlreadyCommunicated==2">
					<div class="title">已投递</div>
				</div>
				<div class="headerContainer" v-else="isAlreadyCommunicated==1">
					<div class="title">已投递</div>
				</div>
				<div class="stateContainer" v-if="isAlreadyCommunicated!=2&&isResumeDatabase!=1">
					<div class="messageTabs flex-h" style="justify-content: flex-start;margin-top: 20px;">
						<el-tabs v-model="activeName" @tab-click="handleClick" class="flex1">
							<el-tab-pane label="全部" name="first"></el-tab-pane>
							<el-tab-pane label="新招呼" name="second" v-if="hasLogin"></el-tab-pane>
							<el-tab-pane label="沟通中" name="third" v-if="hasLogin"></el-tab-pane>
						</el-tabs>
						
					</div>
				</div>
			</div>




			<template v-if="isResumeDatabase==0">
				<div class="list">
					<div class="listContainer" v-loading="loading1">
						<div v-for="(i, index) in allChatList" :key="index" style="padding: 0 10px">
							<!-- v-if="i.status === tabIndex || tabIndex === 0" -->
							<div class="item">
								<div class="logo" style="position: relative;">
																		<student-avatar :avatar="i.to_chat_logo" :name="i.to_chat_name"
																			:user-id="i.user_id" :gender="i.to_gender" :size="57" />
																		<span v-if="getUnreadMessageCount(i.user_id) > 0" class="message-unread-dot">{{ getUnreadMessageCount(i.user_id) > 99 ? '99+' : getUnreadMessageCount(i.user_id) }}</span>
																	</div>
								<div class="left" style="padding-left: 10px;box-sizing: border-box;">
									<div class="center">
										<div class="nameContainer">
											<div class="name" v-if="i.to_chat_name && i.to_chat_name != ''">
												{{ i.to_chat_name }}
											</div>
										<div class="tag" :style="log_type === 2 ? 'opacity:1' : 'opacity:0'">
											{{ i.to_academy_name }} · {{ i.to_major_name }} · {{ i.to_graduation_year }}
										</div>
										</div>
										<div class="msg" v-if="i.is_recall==1">
											[{{ i.status === 1 ? '新招呼' : '沟通中' }}]&nbsp;&nbsp;{{i.source==2?'你':'“'+i.to_chat_name+'”'}}撤回了一条消息
										</div>
										<div class="msg two-line" v-else>
											[{{ i.status === 1 ? '新招呼' : '沟通中' }}]&nbsp;&nbsp;{{ i.type === 1 ? i.content : i.type === 2 ? '[图片]' : i.type === 8 ? '[语音]' : i.type === 7 ? '[附件]' : i.type === 6 ? '[招生信息]' : i.type === 9 ? '[位置]' : i.type === 3 ||i.type>10? i.content : '您好,您与我们的岗位要求很符合,请问可以沟通下吗？' }}
										</div>
									</div>
									<div class="time">{{ i.created_at |convertTime}}</div>
								</div>
								<!-- <div class="right" @click="openChatFrame(i)">去沟通</div> -->
								<el-button type="primary" @click="openChatFrame(i)">沟通联系</el-button>
							</div>
						</div>
						<div v-if="allChatList.length === 0">
							<div>
								<!-- <el-empty :img-size="200" description="暂无聊天消息"></el-empty> -->
								<el-empty :description="hasLogin?'暂无聊天消息':' '">
									<!-- #1e40af -->
									<div class="" @click="toLogin"
										style="font-size: 14px;padding: 8px 15px;color: #1e40af;border-radius: 20px;border: 1px solid #1e40af;cursor: pointer;"
										v-if="!hasLogin">
										点击登录/注册
									</div>
								</el-empty>
							</div>
						</div>

					</div>
				</div>
				<div class="paging" v-if="allChatList.length > 0&&isAlreadyCommunicated!=2">
					<div class="pagingLeft">
						<el-button plain @click="previousChatPage" :disabled='currentPage == 1'>上一页</el-button>
						<el-button plain @click="nextChatPage" :disabled='isNextPage'>下一页</el-button>
						<!-- <div class="delete" style="margin-left: 10px">
            <el-button type="danger" @click="deleteJobItem" plain>批量删除</el-button>
          </div> -->
					</div>
					<el-pagination background layout="prev, pager, next" :page-size="pageSizes" :total="total"
						@current-change="currentChange1" :current-page="currentPage"> </el-pagination>
				</div>
			</template>

			<template v-else>
				<div ref="selectContainer" class="selectContainer resume-filter-panel" style="padding: 0 40px;display: flex;justify-content: space-between;">
					<!-- <div class="stateContainer" >
						<el-tabs v-model="positionName" @tab-click="tabClick1">
							<el-tab-pane label="全部" name="first"></el-tab-pane>
							<el-tab-pane :label="item" :name="'name'+index" v-for="(item,index) in jobnameList" :key='index'></el-tab-pane>
						</el-tabs>
					</div>
					<div class="stateContainer" >
						<el-tabs v-model="statusName" @tab-click="tabClick">
							<el-tab-pane label="所有（18）" name="first"></el-tab-pane>
							<el-tab-pane label="简历未读（3）" name="second" v-if="hasLogin"></el-tab-pane>
							<el-tab-pane label="感兴趣（9）" name="third"  v-if="hasLogin"></el-tab-pane>
							<el-tab-pane label="待定（3）" name="fourth" v-if="hasLogin"></el-tab-pane>
							<el-tab-pane label="不合适（2）" name="fifth"  v-if="hasLogin"></el-tab-pane>
						</el-tabs>
					</div> -->
					<div class="resume-filter-options" >
						<div class="stateContainerx1 flex-h">
							<div class="title">
								全部职位
							</div>
						
							<div ref="jobTags" class="job-tags" :style="{ maxWidth: jobTagsMaxWidth + 'px' }">
								<div class="tags1 tags2" :class="{ 'is-active': item.isSelect }" v-for="(item,index) in visibleJobNameList" :key='index' :title="item.name" @click="tabClick1(index)">
									{{formatJobName(item.name)}}
								</div>
							</div>
							<el-popover v-if="showJobMore" v-model="jobMoreVisible" placement="bottom-start" trigger="click" popper-class="resume-job-more-popper">
								<div class="job-more-list">
									<div v-for="(item,index) in jobnameList" :key="'more-' + index" :class="{ 'is-active': item.isSelect }" :title="item.name" @click="tabClick1(index)">{{formatJobName(item.name)}}</div>
								</div>
								<div slot="reference" class="job-more" :class="{ 'is-active': isSelectedJobHidden }" :title="moreJobName"><span>{{moreJobName}}</span><i class="el-icon-arrow-down"></i></div>
							</el-popover>
							<!-- <div class="filter-reset" @click="resetResumeFilters">重置</div> -->
						
							
						</div>
						<div class="stateContainerx1 flex-h" style="margin-top: 10px;">
							<div class="title">
								简历状态
							</div>
							
							<div class="tags1 status-tag" :class="{ 'is-active': statusIndex == 0 }" @click="tabClick(0)">
								全部<span>{{num1}}</span>
							</div>

							<div class="tags1 status-tag" :class="{ 'is-active': statusIndex == 1 }" @click="tabClick(1)">
								简历未读<span>{{num2}}</span>
							</div>

							<div id="resume-status-2" class="tags1 status-tag" :class="{ 'is-active': statusIndex == 2 }" @click="tabClick(2)">
								感兴趣<span>{{num3}}</span>
							</div>

							<div id="resume-status-3" class="tags1 status-tag" :class="{ 'is-active': statusIndex == 3 }" @click="tabClick(3)">
								待定<span>{{num4}}</span>
							</div>

							<div id="resume-status-4" class="tags1 status-tag" :class="{ 'is-active': statusIndex == 4 }" @click="tabClick(4)">
								不合适<span>{{num5}}</span>
							</div>
						</div>
						</div>
						
						<div class="resume-filter-tools">
							<div class="resume-quota-panel">
								<div class="resume-quota-item"><span>简历总额度</span><strong>{{resumeQuota.total}}</strong><em>个</em></div>
								<div class="resume-quota-item"><span>简历已用额度</span><strong>{{resumeQuota.used}}</strong><em>个</em></div>
								<div class="resume-quota-item"><span>简历剩余额度</span><strong>{{resumeQuota.remaining}}</strong><em>个</em></div>
								<div class="resume-download-button" @click="goResumeDownload">简历下载 <i class="el-icon-download" :class="{'is-downloading': resumeDownloading}"></i></div>
							</div>
						<div class="search resume-search">
							<img src="../img/search2.png" alt="" />
							<input type="text" placeholder="可按姓名、学校、专业、投递职位等搜索简历" v-model='searchName' @keyup.enter="toSearch"/>
							<div class="" style="width: 30px;cursor: pointer;" @click="toSearch">
								搜索
							</div>
							<div v-if="searchName" class="" style="width: 30px; margin-left: 5px;cursor: pointer;" @click="resetResumeSearch">
								重置
							</div>
						</div>
						</div>
					

				</div>

				<div class="resumeDatabase resume-library-content" style="background: #F0F4FA;padding: 10px 10px;min-height: 700px;" >
					
					<div class="list homeList" v-if="recordList.length>0">
						<div class="item resume-card" v-for="(item,index) in recordList" :key="index" :id="'resume-card-' + item.id">
							<div class="" style="">
								<div class="studentInfo">



									<div class="left" style="height: 55px;">
										<div class="nameContainer"
											style="display: flex;justify-content: space-around;flex-direction: column;height: 55px;">
											<div class="name" v-if="nextToken">
												{{item.realname || item.username || item.name }}
											</div>
											<div class="name" v-else>
												{{item.realname?item.realname.charAt(0)+'同学':item.username?item.username.charAt(0)+'同学':item.name?item.name.charAt(0)+'同学':''}}
											</div>

											<div class="other">
												{{item.gender===1?'男':'女'}}·{{item.age|replaceAge}}·{{item.highest_education || '本科'}}{{item.graduation_year?'·'+item.graduation_year:''}}
											</div>
											<!-- item.level_name || '大四' -->
										</div>
									</div>


									<div class="right" style="position: relative;">
										<student-avatar :avatar="item.avatar" :name="item.realname || item.username || item.name"
											:user-id="item.user_id" :gender="item.gender" :size="55" />
										<div class="shortVideo" v-if="item.filelist&&item.filelist.url">
											简历
										</div>
									</div>
									<!-- <div class="" style="display: flex;align-items: center;">
										<div class=""
											style="color: #FFF;border: 1px solid #0176FA;color:#0176FA;width:60px;height: 25px;text-align: center;line-height: 23px;font-size: 12px;border-radius: 25px;cursor: pointer;box-sizing: border-box;margin-right:5px;">
											简历预览
										</div>
										<div class=""
											style="color: #FFF;border: 1px solid #3fc051;color:#3fc051;width:60px;height: 25px;text-align: center;line-height: 23px;font-size: 12px;border-radius: 25px;cursor: pointer;box-sizing: border-box;">
											简历下载
										</div>
									</div> -->


								</div>
								<div class="education one-line" style="margin-bottom: 5px;">
									<span v-if="item.academy_name || item.major_name">
										{{item.academy_name}}
										<span v-if="item.academy_name && item.major_name">·</span>
										{{item.major_name || ''}}
									</span>
									<span v-else>
										{{item.schoolName}}
										<span v-if="item.schoolName && item.department">·</span>
										{{item.department || ''}}
									</span>
								</div>

								<div class="intentionContainer">
									<div class="intentionitem " style="margin-bottom:5px;">
										<img src="../img/position.png" alt="" />
										<div class="one-line">
											投递职位：{{item.job_name?item.job_name.replace(/,/g,'，'):'暂无'}}
											<!-- <span v-if="item.salary_max || item.salary_min">
												{{' · '}}{{item.salary_min+'-'+item.salary_max+'k'}}
											</span>
											<span v-else>{{' · '}}面议</span> -->
										</div>
									</div>
								</div>

								<!-- <div class="skillTag" v-if="item.hobbyList">
									<div class="tagItem" v-for="(item,index) in item.hobbyList" :key="index">
										{{item}}
									</div>
								</div> -->

								<div class="briefIntroduction resume-submit-info"
									style="border-bottom: 1px solid #e8eaf7; display: flex;align-items: center;justify-content: space-between;">

									<div class="briefIntroductionLeft two-line">
										投递时间：{{item.created_at}}
										<!-- {{item.personal_summary | replaceNr}} -->
									</div>

									<div class="resume-status" :class="'resume-status-' + (item.score_status || 1)">
										<!-- <i :class="item.score_status === 2 ? 'el-icon-success' : item.score_status === 3 ? 'el-icon-remove-outline' : item.score_status === 4 ? 'el-icon-circle-close' : 'el-icon-more-outline'"></i> -->
                                        
                                        <img :src="item.score_status === 2 ? 'https://oss.sx985.com/2026/08/10/aaaax2.png' : item.score_status === 3 ? 'https://oss.sx985.com/2026/08/10/aaaax3.png' : item.score_status === 4 ? 'https://oss.sx985.com/2026/08/10/aaaax4.png' : 'https://oss.sx985.com/2026/08/10/aaaax1.png'"  alt=""
                                        	style="width: 16px;height: 16px;margin-right: 2px;" />
										<span>{{item.score_status === 2 ? '感兴趣' : item.score_status === 3 ? '待定' : item.score_status === 4 ? '不合适' : '未读'}}</span>
									</div>
									<div class="resume-preview-action" @click.stop="previewResume(item)">查看简历</div>
									<div class="resume-legacy-actions" style="display: flex;align-items: center;">
										<div class="" style="display: flex;align-items: center;cursor: pointer;">
											<img src="../img/preview.png" alt=""
												style="width: 15px;height: 15px;margin-right: 2px;" />
											<div class="" style="font-weight: 500;font-size: 14px;color: #5a6374;">
												预览
											</div>
										</div>
										<!-- <div class=""
											style="border-left: 1px solid #d5d7e2;height: 10px;margin: 0 4px;">

										</div>
									<div class="" style="display: flex;align-items: center;cursor: pointer;" @click="download(item)">
											<img src="../img/download.png" alt=""
												style="width: 15px;height: 15px;margin-right: 2px;" />
											<div class="" style="font-weight: 500;font-size: 14px;color: #5a6374;">
												下载
											</div>
										</div> -->
									</div>

								</div>

							</div>
							<div class="btnContainer">
								<!-- <img src="" alt="" /> -->
								<div class="" style="display: flex;align-items: center;font-size: 0;cursor: pointer;" @click.stop="startFlyAnimation(item,4,index,$event)">
									<img :src="item.score_status===4?'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/27/aui1.png':'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/27/ruser1.png'" alt=""
										style="width: 15px;height: 15px;margin-right: 5px;" />
									<div class="" style="font-size: 14px;color: #5C5C5C;" :style="item.score_status===4?'color:#FF6600':''">
										不合适
									</div>
								</div>

								<div class="" style="display: flex;align-items: center;font-size: 0;cursor: pointer;" @click.stop="startFlyAnimation(item,3,index,$event)">
									<img :src="item.score_status===3?'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/27/aui2.png':'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/27/ruser2.png'" alt=""
										style="width: 15px;height: 15px;margin-right: 5px;" />
									<div class="" style="font-size: 14px;color: #5C5C5C;" :style="item.score_status===3?'color:#FF6600':''">
										待定
									</div>
								</div>

								<div class="" style="display: flex;align-items: center;font-size: 0;cursor: pointer;" @click.stop="startFlyAnimation(item,2,index,$event)">
									<img :src="item.score_status===2?'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/27/aui4.png':'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/05/27/ruser4.png'" alt=""
										style="width: 15px;height: 15px;margin-right: 5px;" />
									<div class="" style="font-size: 14px;color: #5C5C5C;" :style="item.score_status===2?'color:#FF6600':''">
										感兴趣
									</div>
								</div>

								<!-- <div class=""
										style="color: #FFF;background-color: #F56C6C;width:80px;height: 32px;text-align: center;line-height: 32px;font-size: 14px;border-radius: 4px;cursor: pointer;box-sizing: border-box;">
										不合适
									</div>
									<div class=""
										style="color: #FFF;background-color: #909399;width:80px;height: 32px;text-align: center;line-height: 32px;font-size: 14px;border-radius: 4px;cursor: pointer;box-sizing: border-box;">
										待定
									</div>
									<div class=""
										style="color: #FFF;background-color: #1E40AF;width:80px;height: 32px;text-align: center;line-height: 32px;font-size: 14px;border-radius: 4px;cursor: pointer;box-sizing: border-box;">
										感兴趣
									</div> -->
							</div>
							<!-- <div class="briefIntroductionRight" style="cursor: pointer;"
								@click="toInfo(item.id,item.source,item.user_id)">
								查看详情
							</div> -->
						</div>
						
					</div>
					<div class="" style="min-height: 588px;display: flex;align-items: center;justify-content: center;" v-if="recordList.length == 0">
							<!-- <el-empty :img-size="200" description="暂无聊天消息"></el-empty> -->
							<el-empty :description="hasLogin?'暂无数据':' '">
								<!-- #1e40af -->
								<div class="" @click="toLogin"
									style="font-size: 14px;padding: 8px 15px;color: #1e40af;border-radius: 20px;border: 1px solid #1e40af;cursor: pointer;"
									v-if="!hasLogin">
									点击登录/注册
								</div>
							</el-empty>
					</div>

					<div class="paging">
						<div class="pagingLeft" :style="total1>12?'opacity:1':'opacity:0'">
							<el-button plain @click="previousPage" :disabled='currentpage==1'>上一页</el-button>
							<el-button plain @click="nextPage" :disabled='isNextPage1'>下一页</el-button>
							<!-- <el-button type="danger" plain>删除</el-button> -->
						</div>
						<el-pagination background layout="prev, pager, next,jumper" :page-size='pageSizes1'
							:total="total1" @current-change='currentChange' :current-page='currentpage'>
						</el-pagination>
					</div>

				</div>
				<div v-if="flyCard.show" class="resume-fly-card" :style="flyCardStyle">
					<student-avatar :avatar="flyCard.avatar" :name="flyCard.name" :user-id="flyCard.userId" :gender="flyCard.gender" :size="48" />
				</div>
			</template>

			<el-dialog :visible.sync="resumePreviewVisible" :show-close="false" :close-on-click-modal="false" :before-close="requestCloseResumePreview" width="670px !important"  custom-class="resume-preview-dialog" @closed="closeResumePreview">
				<div class="resume-preview-modal">
					<div class="resume-preview-header">
						<div class="resume-preview-title"><span></span>查看简历</div>
						<div class="resume-preview-download" @click="download(resumePreview.item)"><i class="el-icon-download"></i> 简历下载</div>
						<i class="el-icon-close resume-preview-close" @click="requestCloseResumePreview"></i>
					</div>
					<div class="resume-preview-body" v-loading="resumePreview.loading">
						<div class="resume-preview-error" v-if="resumePreview.error">{{resumePreview.error}}</div>
						<div class="resume-preview-pages" v-else>
							<img v-for="(page, pageIndex) in resumePreview.pages" :key="pageIndex" :src="page" :alt="'简历第 ' + (pageIndex + 1) + ' 页'" />
						</div>
					</div>
					<div class="resume-preview-actions">
						<div class="resume-preview-status resume-preview-status-interested" :class="{'is-selected': resumePreview.status===2}" @click="setResumePreviewStatus(2)"><i class="el-icon-success"></i>感兴趣</div>
						<div class="resume-preview-status resume-preview-status-pending" :class="{'is-selected': resumePreview.status===3, 'is-disabled': resumePreview.status===2 && resumePreview.statusSet}" @click="resumePreview.status===2 && resumePreview.statusSet ? null : setResumePreviewStatus(3)"><i class="el-icon-remove-outline"></i>待定</div>
						<div class="resume-preview-status resume-preview-status-unsuitable" :class="{'is-selected': resumePreview.status===4, 'is-disabled': resumePreview.status===2 && resumePreview.statusSet}" @click="resumePreview.status===2 && resumePreview.statusSet ? null : setResumePreviewStatus(4)"><i class="el-icon-circle-close"></i>不合适</div>
						<div v-if="resumePreview.status===2 && resumePreview.statusSet" class="resume-preview-chat" @click="openResumePreviewChat">去沟通</div>
					</div>
				</div>
			</el-dialog>
			<el-dialog :visible.sync="resumeStatusRequiredVisible" width="420px" top="50vh !important" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" custom-class="resume-status-required-dialog">
				<div class="resume-status-required-title">您对{{resumePreview.item && (resumePreview.item.realname || resumePreview.item.username || resumePreview.item.name)}}的简历</div>
				<!-- <div class="resume-status-required-name">{{resumePreview.item && (resumePreview.item.realname || resumePreview.item.username || resumePreview.item.name)}}的简历</div> -->
				<div class="resume-status-required-actions">
					<div :class="{'is-selected': resumePreview.status===2}" @click="setResumePreviewStatus(2, true)"><i class="el-icon-success"></i>感兴趣</div>
					<div :class="{'is-selected': resumePreview.status===3}" @click="setResumePreviewStatus(3, true)"><i class="el-icon-remove-outline"></i>待定</div>
					<div :class="{'is-selected': resumePreview.status===4}" @click="setResumePreviewStatus(4, true)"><i class="el-icon-circle-close"></i>不合适</div>
				</div>
			</el-dialog>

			<div id="">
				<el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :show-close="false" width="465px"
					@closed="handleChatDialogClosed" @open='eldialogOpen'>
					<div class="elDialog">
						<img class="close" @click="closeElDialog" src="../img/close.png" alt="" />
						<div class="main">
							<div class="userName">回复{{ to_chat_name }}</div>
							<div class="ans-qws-wrap" v-loading="loading" ref="scrollContainer">
								<div v-for="(item, index) in newsList" :key="index">
									<div class="time-title flex-h" v-if="item.is_showtime" style="margin-bottom: 10px">
										<div style="height: 20rpx; font-size: 14px">{{ item.created_at | convertTime1 }}
										</div>
									</div>
									<div class="content-box" v-if="item.type === 4 && log_type === 2"
										style="cursor: pointer">
										<div>
											<div class="job-item-box" @click="goJobDetail(item)">
												<div class="item-title flex-h">
													<span class="left"
														:style="item.content.is_hurry ? 'max-width:440px' : 'max-width:460px'">{{ item.content.job_name }}</span>
													<span class="ji" v-if="item.content.is_hurry">急招</span>
													<span class="right flex1">{{ item.content.salary_k }}</span>
												</div>
												<div class="item-block flex-h">
													<span
														v-if="item.content.education">{{ item.content.education }}</span>
													<span
														v-if="item.content.industry">{{ item.content.industry }}</span>
												</div>
												<div class="company-name flex-h">
													<div v-if="log_type === 2">
														<img class="logo" :src="schoolData.logo || defaultimg"
															mode="" />
														<!-- v-if="schoolData.logo"
												<span v-else
													class="logo logo-text">{{ schoolData.company_name.substring(0, 1) }}</span> -->
													</div>
													<img class="logo" v-else :src="schoolData.base_info.badge"
														mode="" />

													<span>{{ item.content.company_name }}
														{{ item.content.scale }}</span>
													<span class="flex1"></span>
												</div>
											</div>
										</div>
									</div>


									<div v-if="item.source === 2" @mouseenter="hoverIndex = index"
										@mouseleave="hoverIndex = null">
										<div class="" v-if="item.is_recall!=1">
											<div class="flex-h answer" style="margin-bottom: 0;"
												v-if="item.type === 1||item.type>10">
												<div class="flex1" style="width: 150px; min-width: 52px"></div>
												<div class="content txt" style="background: #89d961; max-width: 458px">
													{{ item.content }}
												</div>
												<div v-if="log_type === 2">
													<img class="logo" :src="schoolData.logo || defaultimg" mode="" />
													<!-- v-if="schoolData.logo"
										<span v-else class="logo-text">{{ schoolData.company_name }}</span> -->
												</div>
												<img class="logo" v-else :src="schoolData.base_info.badge" mode="" />
												<div class="sanj" style="border-left-color: #89d961"></div>
											</div>

											<div v-if="item.type === 2">
												<div class="flex-h answer" style="margin-bottom: 0;"
													v-for="i in item.url_list" :key="i">
													<div class="flex1" style="width: 150px; min-width: 52px"></div>
													<div class="content txt"
														style="max-width: 458px; background: none; padding-right: 0">
														<img @click="openImg(i)"
															style="max-width: 458px; width: 100px; border-radius: 6px"
															:src="i" mode="widthFix" />
													</div>
													<div v-if="log_type === 2">
														<img class="logo" :src="schoolData.logo || defaultimg"
															mode="" />
														<!-- v-if="schoolData.logo" -->
														<!-- <span v-else class="logo-text">{{ schoolData.company_name }}</span> -->
													</div>
													<img class="logo" v-else :src="schoolData.base_info.badge"
														mode="" />
													<div class="sanj" style="border-left-color: #89d961; opacity: 0">
													</div>
												</div>
											</div>
											<div class="flex-h answer" style="margin-bottom: 0;" v-if="item.type === 3">
												<div class="flex1" style="width: 150px"></div>
												<div class="flex-h content"
													style="background: #fff; max-width: 274px; min-width: 204px; padding: 10px 20px; align-items: stretch"
													@click="openPdf(item)">
													<div class="felx1" style="max-width: 274px; min-width: 204px">
														<div class="txt"
															style="padding-bottom: 10px; padding-top: 10px">
															{{ item.file_name }}
														</div>
														<div class="size-txt">
															{{ item.file_size || '' }}
														</div>
													</div>
													<img style="width: 80px; height: 80px; margin-left: 5px"
														:src="item.url.indexOf('pdf') > -1 ? 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/08/21/ltvxmtpuavbklbzw.png' : 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/08/21/u6tvmnyq2zcec6cs.png'"
														mode="" />
												</div>

												<div v-if="log_type === 2">
													<!-- v-if="schoolData.logo" -->
													<img class="logo" :src="schoolData.logo || defaultimg" mode="" />
													<!-- <span v-else class="logo-text">{{ schoolData.company_name }}</span> -->
												</div>
												<img class="logo" v-else :src="schoolData.base_info.badge" mode="" />
												<div class="sanj" style="border-left-color: #fff"></div>
											</div>
											<div v-if="item.type === 5">
												<div class="flex-h answer"
													style="font-size: 28px; color: #999;margin-bottom: 0;">请求交换微信已发送
												</div>
											</div>
											<div class="flex-h answer" style="margin-bottom: 0;" v-if="item.type === 6">
												<div class="flex1" style="width: 150px"></div>
												<div class="content txt" style="background: #89d961; max-width: 458px">
													<div class="content-school-box">
														<div class="school-title">
															{{ item.content.schoolName }}
														</div>
														<div class="flex-h school-desc">
															<span class="l1">学校地址：</span>
															<span class="l2 flex1">{{ item.content.address }}</span>
														</div>
														<div class="flex-h school-desc">
															<span
																class="l1">{{ log_type === 1 ? '研招' : '学校' }}官网：</span>
															<span class="l2 flex1 l3"
																@click="copySite(item.content.website, `${log_type === 1 ? '研招' : '学校'}官网`)">{{ item.content.website }}</span>
														</div>
													</div>
												</div>
												<img class="logo" :src="schoolData.base_info.badge" mode="" />
												<div class="sanj" style="border-left-color: #89d961"></div>
											</div>
											<div class="flex-h answer" style="margin-bottom: 0;" v-if="item.type === 7">
												<div class="flex1" style="width: 150px"></div>
												<div class="content txt"
													style="background: #fff; max-width: 274px; min-width: 200px"
													@click="openPdf(item, 1)">
													<div class="file-box flex-h">
														<div class="flex1">
															<div class="f-t-1">{{ item.content[0] }}</div>
															<span class="f-t-2">{{ item.content[2] | getSize }}</span>
														</div>
														<img v-if="item.content[1]"
															style="width: 50px; height: 50px; margin-left: 5px"
															:src="item.content[1].indexOf('.pdf') > -1 ? 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2024/05/01/document_pdf.png' : item.content[1].indexOf('.doc') > -1 ? 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2024/05/01/document_word.png' : 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2024/05/01/document_x.png'"
															mode="" />
													</div>
												</div>
												<div v-if="log_type === 2">
													<img class="logo" :src="schoolData.logo || defaultimg" mode="" />
													<!-- v-if="schoolData.logo"
										<span v-else class="logo-text">{{ schoolData.company_name }}</span> -->
												</div>

												<img class="logo" v-else :src="schoolData.base_info.badge" mode="" />
												<div class="sanj" style="border-left-color: #fff"></div>
											</div>
											<div class="flex-h answer" style="margin-bottom: 0;" v-if="item.type === 8">
												<div class="flex1" style="width: 150px"></div>
												<div class="content txt" style="background: #89d961; max-width: 300px"
													@click="playAudio(item.content.audioUrl, index)">
													<div class="audio-facade">

														<div class="audio-facade-bg"
															:class="audioPlayerUrl === item.content.audioUrl ? 'play-icon' : ''">
														</div>
														<div>{{ item.content.audioSize | replaceNum }}<span>"</span>
														</div>
													</div>
													<audio :src="item.content.audioUrl" :ref="'audio' + index" controls
														style="display: none" preload="metadata">您的浏览器不支持音频播放</audio>
												</div>
												<div v-if="log_type === 2">
													<img class="logo" :src="schoolData.logo || defaultimg" mode="" />
													<!-- v-if="schoolData.logo"
										<span v-else class="logo-text">{{ schoolData.company_name }}</span> -->
												</div>

												<img class="logo" v-else :src="schoolData.base_info.badge" mode="" />
												<div class="sanj" style="border-left-color: #89d961"></div>
											</div>
											<div class="flex-h answer" style="margin-bottom: 0;" v-if="item.type === 9">
												<div class="flex1" style="width: 150px"></div>
												<div class="content txt"
													style="max-width: 300px; background: none; padding-right: 0"
													@click="openLocation(item.content)">
													<div class="map-box">
														<span class="tt1">{{ item.content.name }} </span>
														<span class="tt2">{{ item.content.address }} </span>
													</div>
													<img style="width: 244px; border-radius: 6px; height: 96px"
														:src="`https://apis.map.qq.com/ws/staticmap/v2/?center=${item.content.lat},${item.content.lon}&zoom=10&markers=icon:https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2024/06/19/klosngrvnliwq5hu.png|${item.content.lat},${item.content.lon}&key=LXDBZ-76YWQ-NO55J-4XDR5-UMS3E-RDFA2&size=440*170&scale=2`"
														mode="widthFix" />
												</div>
												<div v-if="log_type === 2">
													<img class="logo" :src="schoolData.logo || defaultimg" mode="" />
													<!-- v-if="schoolData.logo"
										<span v-else class="logo-text">{{ schoolData.company_name }}</span> -->
												</div>

												<img class="logo" v-else :src="schoolData.base_info.badge" mode="" />
												<div class="sanj" style="border-left-color: #ffffff"></div>
											</div>

											<div class="" style="height:47px;">
												<div class="revocation"
													v-if="item.is_recall!=1&&hoverIndex==index&&isredact(item)">
													<el-tooltip style="width:24px;height: 24px;" effect="dark"
														content="撤回" placement="top">
														<div class="item" @click="handleLongPress(item,index)">
															<img src="../img/revocation.png" alt="" />
														</div>
													</el-tooltip>
												</div>
											</div>
										</div>

										<div class="" v-else
											style="display: flex;align-items: center;justify-content: center;margin-bottom: 15px;">
											<div class=""
												style="font-size: 14px;line-height: 20px;font-weight: 500;color: #999;"
												:style="isredact(item)?'margin-right: 20px;':''">
												你撤回了一条消息
											</div>
											<div class="" v-if="isredact(item)">
												<div class=""
													style="font-size: 14px;font-weight: 400;color: #676b8f;cursor: pointer;"
													@click="redact(item)" v-if="item.type===1">
													重新编辑
												</div>
											</div>
										</div>
									</div>







									<div v-if="item.source === 1">
										<div class="" v-if="item.is_recall!=1">
											<div class="flex-h school" v-if="item.type === 1||item.type>10">
													<student-avatar :avatar="item.to_chat_logo" :name="item.to_chat_name"
														:user-id="item.user_id" :gender="to_chat_gender" :size="40" />
												<!-- <span v-else class="logo logo-text">{{ item.to_chat_name }}</span> -->
												<div class="content txt" style="max-width: 274px">
													{{ item.content }}
												</div>
												<div style="width: 150px min-width: 52px" class="flex1"></div>
												<div class="sanj"></div>
											</div>
											<div class="flex-h school" v-if="item.type === 3">
													<student-avatar :avatar="item.to_chat_logo" :name="item.to_chat_name"
														:user-id="item.user_id" :gender="to_chat_gender" :size="40" />
												<div class="flex-h content"
													style="background: #fff; max-width: 274px; min-width: 200px; padding: 10px; align-items: stretch"
													@click="openPdf(item, 0)">
													<div class="felx1" style="max-width: 274px; min-width: 200px">
														<div class="txt"
															style="padding-bottom: 10px; padding-top: 10px">
															{{ item.file_name }}
														</div>
														<div class="size-txt">
															{{ item.file_size || '' }}
														</div>
													</div>
													<img style="width: 50px; height: 50px; margin-left: 5px"
														:src="item.url.indexOf('pdf') > -1 ? 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/08/21/ltvxmtpuavbklbzw.png' : 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/08/21/u6tvmnyq2zcec6cs.png'"
														mode="" />
												</div>
												<div style="width: 150px" class="flex1"></div>
												<div class="sanj"></div>
											</div>
											<div v-if="item.type === 2">
												<div class="flex-h school" v-for="i in item.url_list" :key="i">
														<student-avatar :avatar="item.to_chat_logo" :name="item.to_chat_name"
															:user-id="item.user_id" :gender="to_chat_gender" :size="40" />
													<div class="content txt"
														style="max-width: 458px; background: none; padding-left: 0">
														<img @click="openImg(i)"
															style="max-width: 458px; width: 100px; border-radius: 6px"
															:src="i" mode="widthFix" />
													</div>
													<div style="width: 150px" class="flex1"></div>
													<div class="sanj" style="opacity: 0"></div>
												</div>
											</div>
											<div v-if="item.type === 5">
												<div class="flex-h school">
														<student-avatar :avatar="item.to_chat_logo" :name="item.to_chat_name"
															:user-id="item.user_id" :gender="to_chat_gender" :size="40" />
													<div class="content txt wechat-box" style="max-width: 458px">
														<div class="title">是否同意交换微信</div>
														<div class="wechat-btn flex-h">
															<span class="wc wl flex1"
																@click="sureWechat('抱歉我不能提供我的微信号')">否</span>
															<span class="wc flex1"
																@click="sureWechat(`我的微信号码是${item.content}`)">是</span>
														</div>
													</div>
													<div style="width: 150px" class="flex1"></div>
													<div class="sanj" style="opacity: 0"></div>
												</div>
											</div>
											<div class="flex-h school" v-if="item.type === 8">
													<student-avatar :avatar="item.to_chat_logo" :name="item.to_chat_name"
														:user-id="item.user_id" :gender="to_chat_gender" :size="40" />
												<!-- <span v-else class="logo logo-text">{{ item.to_chat_name }}</span> -->

												<div class="content txt" style="max-width: 274px"
													@click="playAudio(item.content.audioUrl, index)">
													<div class="audio-facade">
														<div class="audio-facade-bg"
															:class="{ 'play-icon': audioPlayerUrl === item.content.audioUrl }">
														</div>
														<div style="font-size: 14px">
															{{ item.content.audioSize | replaceNum }}<span></span>
														</div>
													</div>

													<audio :src="item.content.audioUrl" :ref="'audio' + index" controls
														style="display: none" preload="metadata">您的浏览器不支持音频播放</audio>
													<!-- <audio :src="item.content.audioUrl" ref="audio" controls style="display: none"
											preload="metadata">
											您的浏览器不支持音频播放
										</audio> -->
												</div>
												<div style="width: 150px" class="flex1"></div>
												<div class="sanj"></div>
											</div>
										</div>
										<div class="" v-else
											style="display: flex;align-items: center;justify-content: center;margin-bottom: 15px;">
											<div class=""
												style="font-size: 14px;line-height: 20px;font-weight: 500;color: #999;">
												“{{item.to_chat_name}}”撤回了一条消息
											</div>
										</div>

									</div>



								</div>
								<div style="height: 30px; width: 100%"></div>
							</div>

							<div class="chartTool">
								<div class="usefulExpressions">
									<!-- <el-popover placement="top" width="485" v-model="visible"> -->
									<!-- overflow-y: scroll; -->

									<div class="usefulExpressionsBtn" @click="changeUsefulExpressions">常用语</div>
									<!-- slot="reference" -->
									<!-- </el-popover> -->
								</div>
								<div class="">
									<el-popover placement="top" width="485" v-model="visible1" @show="popoverShow">
										<div class="emjoiContainer"
											style="display: grid; grid-template-columns: repeat(8, 1fr); grid-gap: 10px 10px; height: 200px; overflow-y: scroll">
											<div class="item" @click="selectExp(item)" v-for="(item, index) in emjoi"
												:key="index" style="font-size: 20px; cursor: pointer">
												{{ item }}
											</div>
										</div>
										<img class="expression" src="../img/expression.png" alt="" slot="reference" />
									</el-popover>
								</div>
								<div class="">
									<el-popover placement="top" width="340" v-model="visible2" @show="popoverShow">
										<!-- <p>这是一段内容这是一段内容确定删除吗？</p> -->
										<div class="expression-scrool">
											<div class="send-box flex-h">
												<el-upload accept=".png, .jpg, .jpeg" class="avatar-uploader1"
													action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
													:show-file-list="false" :on-success="handleAvatarSuccess1"
													:before-upload="beforeAvatarUpload1">
													<div class="item">
														<img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/03/06/kvkrygubqi5nqatn.png"
															mode="" />
														<span>上传照片</span>
													</div>
												</el-upload>
												<el-upload accept=".pdf,.doc,.docx,.xls,.xlsx" class="avatar-uploader1"
													:show-file-list="false"
													action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
													:file-list="fileList" :on-change="handleChange">
													<div class="item">
														<img src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/03/06/kvkrygubqi5nqatn.png"
															mode="" />
														<span>上传附件</span>
													</div>
												</el-upload>
											</div>
										</div>
										<img class="more4" src="../img/more4.png" alt="" slot="reference" />
									</el-popover>
								</div>
							</div>
							<el-collapse-transition>
								<!--  -->
								<div class="emjoiContainer"
									style=" box-shadow: inset rgba(0, 0, 0, 0.1) 0px 0px 6px 0px; margin-bottom: 10px; padding: 10px 20px 10px 20px;"
									v-show="usefulExpressions">
									<div class="btn" @click="addUsefulExpressions" style="margin-bottom: 5px;">添加</div>


									<div class="" style="height: 115px;overflow-y: scroll;">
										<div class="" style="display: flex;align-items: center;"
											v-for="(item, index) in txtlist" :key="index">
											<div class="item " @click="userAsk(item)" :title='item'
												style="font-size: 13px; cursor: pointer; padding: 10px 10px; border-bottom: 1px solid #e5e5e5;flex: 1;"
												:style="index == txtlist.length - 1 ? 'border:none;' : ''">
												<div class="" style="display: flex;align-items: center;height: 36px;">
													<div class="two-line" style="">
														{{ item }}
													</div>
												</div>
											</div>
											<div class="btn" style="margin-right: 10px;"
												@click="editUsefulExpressions(item,index)">编辑</div>

											<div class="btn" v-if="txtlist.length>1" style="background: #F56C6C;"
												@click="deleteUsefulExpressions(index)">删除</div>
											<div class="btn" v-else
												style="background: #F56C6C;opacity: 0.5;cursor: not-allowed;">删除</div>

										</div>
									</div>


								</div>
							</el-collapse-transition>
							<div class="textareaContainer">
								<el-input type="textarea" style="flex: 1; margin-bottom: 10px" autosize
									placeholder="和Ta聊一聊" v-model="replyTxt" maxlength="500"
									v-on:keyup.enter.native="userAsk(0)"> </el-input>
								<div class="submit" @click="userAsk(0)">
									<div class="btn">发送</div>
								</div>
							</div>
						</div>
					</div>
				</el-dialog>
			</div>
		</div>

		<el-dialog :visible.sync="dialogVisibleImg">
			<div id="" class="img-carousel-box">
				<img :src="dialogImageUrl" alt="" mode="heightFix" />
			</div>
		</el-dialog>
		<el-dialog title="充值提醒" :visible.sync="resumeRechargeVisible" width="520px" top="50vh" :close-on-click-modal="false" custom-class="resume-recharge-reminder">
			<div class="resume-recharge-reminder__content">您的免费使用额度已到上限，充值后可继续查看简历！</div>
			<div slot="footer" class="resume-recharge-reminder__footer"><el-button @click="resumeRechargeVisible = false">取消</el-button><el-button type="primary" @click="goResumeRecharge">去充值</el-button></div>
		</el-dialog>
	</div>
</template>

<script>
	// import chatView from '../components/chatView.vue'
	// import {
	// 	getAllChatList,
	// 	chatRead,
	// 	getChatList,
	// 	postChat,
	// 	schoolJobSend
	// } from '@/api/job.js'
	// import {
	// 	userAsk,
	// 	getSchoolUserQa,
	// 	getUserasklist
	// } from '@/api/studentv2'

	import {
		trim
	} from 'jquery'
	import {
		mapMutations,
		mapState
	} from 'vuex'
	import studentAvatar from '../components/studentAvatar.vue'
	import Qs from 'qs'
	import * as pdfjsLib from 'pdfjs-dist/build/pdf'
	import pdfWorker from 'pdfjs-dist/build/pdf.worker.entry'
	let emjoi = [
		'😀',
		'😃',
		'😄',
		'😁',
		'😆',
		'😅',
		'🤣',
		'😂',
		'🙂',
		'🙃',
		'😉',
		'😊',
		'😇',
		'😍',
		'😘',
		'😗',
		'😙',
		'😋',
		'😛',
		'😜',
		'😝',
		'🤑',
		'🤗',
		'🤔',
		'🤐',
		'😐',
		'😑',
		'😶',
		'😏',
		'😒',
		'🙄',
		'😬',
		'🤥',
		'😌',
		'😔',
		'😪',
		'🤤',
		'😴',
		'😷',
		'🤒',
		'🤕',
		'🤢',
		'🤧',
		'😵',
		'🤠',
		'😎',
		'🤓',
		'😕',
		'😟',
		'🙁',
		'😯',
		'😲',
		'😳',
		'😦',
		'😧',
		'😨',
		'😰',
		'😥',
		'😢',
		'😭',
		'😱',
		'😖',
		'😣',
		'😞',
		'😓',
		'😩',
		'😫',
		'😤',
		'😡',
		'😠',
		'😈',
		'👿',
		'💩',
		'💅',
		'👀',
		'👣',
		'🔪',
		'🎪',
		'🚀',
		'⏰',
		'☔',
		'🎃',
		'🎉',
		'🎁',
		'👓',
		'💊',
		'💟',
		'💯',
		'💢',
		'💥',
		'💫',
		'💦',
		'💨',
		'💣',
		'💤',
		'🀄',
		'🥀',
		'🌻',
		'🌝',
		'🌟',
		'🌜',
		'👋',
		'🤚',
		'🖐',
		'✌',
		'🤘',
		'🤙',
		'👈',
		'👉',
		'👆',
		'🖕',
		'👇',
		'☝',
		'👎',
		'✊',
		'👊',
		'🤛',
		'🤜',
		'👏',
		'👐',
		'🤝',
		'🙏',
		'💪',
		'✍',
		'🐒',
		'🐶',
		'🐕',
		'🐱',
		'🐯',
		'🍇',
		'🍈',
		'🍉',
		'🍊',
		'🍋',
		'🍌',
		'🍍',
		'🍎',
		'🍐',
		'🍑',
		'🍒',
		'🏘',
		'🚌',
		'🚕',
	]
	export default {
		data() {
			return {
				dialogImageList: [],
				dialogImageUrl: '',
				dialogVisibleImg: false,
				fileList: [],
				replyTxt: '',
				newsList: [],
				schoolData: {
					logo: 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/04/15/luvshimm2wkcyplb.png',
					company_name: '公司',
				},
				defaultimg: 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/11/20/avatar_9.png',
				isBtoC: true,
				to_chat_logo: '',
				to_chat_name: '',
				to_chat_gender: '',
				tabIndex: 0,
				allChatList: [],
				unreadMessageMap: {},
				log_type: 2,
				activeName: 'first',
				emjoi: emjoi,
				total: 0,
				pageSizes: 6,
				currentPage: 1,

				dialogVisible: false,

				visible: false,
				visible1: false,
				visible2: false,
				textarea1: '',
				jobData: {
					job_id: 0,
					admin_id: 0,
					user_id: 0,
				},
				loading: true,
				txtlist: ['我看了您的相关经历，想和您聊聊，是否方便呢？', '您好，我想要一份您的附件简历。', '对不起，您暂不符合我们的岗位要求，期待以后有机会合作。'],
				loading1: false,

				audioPlayerUrl: '',
				audioPlayerIndex: '',

				ws: null,
				usefulExpressions: false,

				isAlreadyCommunicated: 0,


				interval: null,
				intervalCount: 0,

				reconnectAttempts: 0,
				maxReconnectAttempts: 15,
				hoverIndex: null,
				getDialogId: 0,

				isResumeDatabase: 0,


				recordList: [],

				total1: 0,
				pageSizes1: 12,
				currentpage: 1,
				loading: false,

				statusName: 'first',

				positionName: 'first',
				
				
				
				positionIndex: -1,
				statusIndex: 0,
				jobnameList: [],
				
				statusList:[],
				
				
				 userList: [],
				 
				 
				 
				 num1:0,
				 num2:0,
				 num3:0,
				 num4:0,
				 num5:0,
				 
				 
				searchName:'',
				searchName1:'',
				resumeQuotaRefreshTimer: null,
				resumeQuota: { total: 0, used: 0, remaining: 0 },
				resumeRefreshing: false,
				resumeDownloading: false,
				resumeRechargeVisible: false,
				resumePreviewVisible: false,
				resumeStatusRequiredVisible: false,
				resumePreviewHistoryPushed: false,
				resumePreviewCloseHandler: null,
				resumePreview: { url: '', item: null, loading: false, error: '', pages: [], status: 0, statusSet: false },
				pendingResumeFly: null,
				resumeStatusFrequentMessage: null,
				jobTagsMaxWidth: 0,
				visibleJobNameCount: 0,
				showJobMore: false,
				jobMoreVisible: false,
				flyCard: { show: false, currentX: 0, currentY: 0, scale: 1, rotateX: 0, rotateY: 0, rotateZ: 0, opacity: 1, shadow: '' },
			}
		},
		filters: {
			replaceNr(val) { //替换空格
				if (val) {
					return val.replace(/[\r\n]+/gm, '')
				} else {
					return '暂无简介'
				}
			},
			replaceAge(val) {
				if (val&&val.indexOf('-') > -1) {
					let birthday = val
					let birth_year = birthday.substring(0, 4)
					let now_yaer = (new Date()).getFullYear()
					return now_yaer - birth_year * 1 + '岁'
				} else {
					if (val) {
						return val.replace('岁', '') + '岁'
					} else {
						return 21 + '岁'
					}
				}

			},
			convertTime1(val) {
				let now = new Date()
				let year = now.getFullYear()
				let month = now.getMonth() + 1
				if (month < 10) {
					month = '0' + month
				}
				let day = now.getDate()
				if (day < 10) {
					day = '0' + day
				}
				let atime = year + '-' + month + '-' + day
				if (val) {
					if (val.substring(0, 10) === atime) {
						return val.substring(11, 16)
					} else {
						return val.substring(5, 16)
					}
				} else {
					return ''
				}
			},
			getSize(val) {
				if (val) {
					if (val * 1 > 1024 * 1024) {
						return Math.ceil((val * 1) / (1024 * 1024)) + 'M'
					} else {
						return Math.ceil((val * 1) / 1024) + 'K'
					}
				} else {
					return ''
				}
			},
			replaceNum(val) {
				if (val) {
					return Math.ceil((val * 1) / 1000)
				} else {
					return 1
				}
			},
			// visible1(){
			// 	this.usefulExpressions = false
			// },
			// visible2(){
			// 	this.usefulExpressions = false
			// }
			convertTime(val) {
				let now = new Date();
				let year = now.getFullYear();
				let month = now.getMonth() + 1;
				if (month < 10) {
					month = '0' + month
				}
				let day = now.getDate();
				if (day < 10) {
					day = '0' + day
				}
				let atime = year + '-' + month + '-' + day;
				if (val) {
					if (year != val.substring(0, 4)) {
						return val.substring(0, 4) + '年' + (val.substring(5, 7) * 1) + '月' + (val.substring(8, 10) *
							1) + '日'
					} else if (val.substring(0, 10) === atime) {
						return val.substring(11, 16)
					} else {

						return (val.substring(5, 7) * 1) + '月' + (val.substring(8, 10) * 1) + '日'
					}

				} else {
					return ''
				}


			}
		},

		computed: {
			// oldData() {
			// 	return this.$store.getters.oldData
			// },

			...mapState({
				hasLogin: (state) => state.nextToken,
				nextToken: (state) => state.nextToken,
				userinfo: (state) => state.userInfo,
				schoolInfo: (state) => state.schoolData,
				adminId: (state) => state.schoolData.admin_id,
			}),
			isredact() {
				return (item) => {
					const messageTime = new Date(item.created_at).getTime();
					const nowTime = new Date().getTime();
					const timeDiff = nowTime - messageTime;

					if (timeDiff <= 2 * 60 * 1000) { // 2分钟内
						return true
					} else {
						return false
					}
				}

			},
			isNextPage() {
				// total
				// pageSizes
				// currentpage
				// console.log(this.currentPage)
				// console.log(Math.ceil(this.total / this.pageSizes))
				if (this.currentPage == Math.ceil(this.total / this.pageSizes) || Math.ceil(this.total / this.pageSizes) ==
					0) {
					return true
				} else {
					return false
				}
			},
			isNextPage1() {
				// total
				// pageSizes
				// currentpage
				// console.log(this.currentPage)
				// console.log(Math.ceil(this.total1 / this.pageSizes1))
				if (this.currentpage == Math.ceil(this.total1 / this.pageSizes1) || Math.ceil(this.total1 / this
						.pageSizes1) == 0) {
					return true
				} else {
					return false
				}
			},
			flyCardStyle() {
				return { left: this.flyCard.currentX + 'px', top: this.flyCard.currentY + 'px', opacity: this.flyCard.opacity, boxShadow: this.flyCard.shadow, transform: 'translate(-50%, -50%) perspective(600px) scale(' + this.flyCard.scale + ') rotateX(' + this.flyCard.rotateX + 'deg) rotateY(' + this.flyCard.rotateY + 'deg) rotateZ(' + this.flyCard.rotateZ + 'deg)' }
			},
			visibleJobNameList() {
				return this.jobnameList.slice(0, this.visibleJobNameCount)
			},
			isSelectedJobHidden() {
				return this.jobnameList.findIndex(item => item.isSelect) >= this.visibleJobNameCount
			},
			moreJobName() {
				const selectedJob = this.jobnameList.find(item => item.isSelect)
				return this.isSelectedJobHidden && selectedJob ? this.formatJobName(selectedJob.name) : '更多'
			}
			// hasLogin() {
			// 	return this.$store.getters.nextToken
			// },
			// userinfo() {
			// 	return this.$store.getters.userinfo
			// },
			// adminId() {
			// 	return this.$store.getters.adminId
			// },
		},
		beforeRouteLeave(to, from, next) {
			if (this.resumePreviewVisible && !this.resumePreview.statusSet) {
				this.requestCloseResumePreview()
				return next(false)
			}
			next()
		},
		mounted() {
			if (!this.adminId) {
				return
			}
			//console.log(this.$route.query.isAlreadyCommunicated)
			clearInterval(this.interval)
			if (this.$route.query.isAlreadyCommunicated && this.$route.query.isAlreadyCommunicated == 1) {
				this.activeName = 'third'
				this.tabIndex = 2
				this.currentPage = 1
				this.chatRead()
				this.log_type = 2
				this.getAllChatList()
				// this.getChatList()
				if (this.$route.query.obj && this.$route.query.obj != '') {
					let item = JSON.parse(this.$route.query.obj)
					this.jobData.job_id = item.job_id
					this.jobData.admin_id = item.admin_id
					this.jobData.user_id = item.user_id
					this.to_chat_name = item.to_chat_name
					this.to_chat_logo = item.to_chat_logo
					this.to_chat_gender = item.to_gender
					this.getChatList(item.user_id, item.job_id, item.admin_id, item.to_chat_name)
					this.dialogVisible = true
				}
				this.schoolData.logo = this.userinfo.avatar
				// this.schoolData.company_name = this.userinfo.username
				let userId = this.userinfo.user_id
				let ids = userId % 26 || 0
				this.defaultimg = `https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/11/20/avatar_${ids}.png`
			} else if (this.$route.query.isAlreadyCommunicated && this.$route.query.isAlreadyCommunicated == 2) {
				this.schoolData.logo = this.userinfo.avatar
				// this.schoolData.company_name = this.userinfo.username
				this.isAlreadyCommunicated = this.$route.query.isAlreadyCommunicated
				this.postUserList()
			} else {
				this.chatRead()
				this.log_type = 2
				this.getAllChatList()
				// this.getChatList()
				if (this.$route.query.obj && this.$route.query.obj != '') {
					let item = JSON.parse(this.$route.query.obj)
					this.jobData.job_id = item.job_id
					this.jobData.admin_id = item.admin_id
					this.jobData.user_id = item.user_id
					this.to_chat_name = item.to_chat_name
					this.to_chat_logo = item.to_chat_logo
					this.to_chat_gender = item.to_gender
					this.getChatList(item.user_id, item.job_id, item.admin_id, item.to_chat_name)
					this.dialogVisible = true
				}
				this.schoolData.logo = this.userinfo.avatar
				// this.schoolData.company_name = this.userinfo.username
				let userId = this.userinfo.user_id
				let ids = userId % 26 || 0
				this.defaultimg = `https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/11/20/avatar_${ids}.png`
			}

			console.log("this.schoolData",this.schoolData)
            console.log('this.schoolInfo',this.schoolInfo)
			if (this.$route.query.resumeDatabase === '1') {
				this.isResumeDatabase = 1
				this.$emit('update-message-management-navigation', true)
			}
			this.dialogList()
			// this.getmyJobList()
			
			this.getJobNameList()
			this.getResumeLibrary()
			this.getResumeLibraryTotal()
			this.getResumeQuota()
			window.addEventListener('resize', this.updateJobTagsLayout)
			window.addEventListener('popstate', this.handleResumePreviewPopstate)
			this.updateJobTagsLayout()
		},
		beforeDestroy() {
			clearInterval(this.interval)
			if (this.resumeQuotaRefreshTimer) clearTimeout(this.resumeQuotaRefreshTimer)
			window.removeEventListener('resize', this.updateJobTagsLayout)
			window.removeEventListener('popstate', this.handleResumePreviewPopstate)
		},
		methods: {
			...mapMutations(['setIslogin']),
			updateJobTagsLayout() {
				this.visibleJobNameCount = this.jobnameList.length
				this.$nextTick(() => {
					const selectContainer = this.$refs.selectContainer
					const jobTags = this.$refs.jobTags
					if (!selectContainer || !jobTags) return
					this.jobTagsMaxWidth = Math.max(selectContainer.clientWidth - 556 - 200 - 100, 0)
					this.$nextTick(() => {
						let usedWidth = 0
						let visibleCount = 0
						Array.prototype.forEach.call(jobTags.children, tag => {
							const style = window.getComputedStyle(tag)
							const tagWidth = tag.offsetWidth + parseFloat(style.marginLeft) + parseFloat(style.marginRight)
							if (usedWidth + tagWidth <= this.jobTagsMaxWidth) {
								usedWidth += tagWidth
								visibleCount++
							}
						})
						this.visibleJobNameCount = visibleCount
						this.showJobMore = visibleCount < this.jobnameList.length
					})
				})
			},
			formatJobName(name) {
				const characters = Array.from(name || '')
				let length = 0
				let result = ''
				for (let index = 0; index < characters.length; index++) {
					length += /[\u3400-\u9fff]/.test(characters[index]) ? 2 : 1
					if (length > 14) return result + '...'
					result += index === 0 && /[a-z]/i.test(characters[index]) ? characters[index].toUpperCase() : characters[index]
				}
				return result
			},
			getResumeQuota() {
				this.$util.post('v2/school_job/get_admin_file_config', { admin_id: this.adminId || 0 }, (res) => {
					const data = res.data || {}
					if (!Object.prototype.hasOwnProperty.call(data, 'total_file_open_limit') ||
						!Object.prototype.hasOwnProperty.call(data, 'file_open_limit')) return
					const total = Number(data.total_file_open_limit)
					const remaining = Number(data.file_open_limit)
					if (!Number.isFinite(total) || !Number.isFinite(remaining)) return
					this.resumeQuota = { total: total, used: Math.max(total - remaining, 0), remaining: remaining }
				})
			},
			refreshResumeQuota() {
				if (this.resumeQuotaRefreshTimer) clearTimeout(this.resumeQuotaRefreshTimer)
				this.resumeQuotaRefreshTimer = setTimeout(() => {
					this.resumeQuotaRefreshTimer = null
					this.getResumeQuota()
				}, 200)
			},
			goResumeDownload() {
				this.$router.push({ path: '/resumeDownload' })
			},
			toMessageSearch() {
				this.$router.push({
					path: '/messageSearch',
				})
			},
			isWordResume(url) {
				return /\.(doc|docx)(?:[?#]|$)/i.test(url || '')
			},
			getResumeReadPayload(item, success) {
				const source = item || {}
				const uid = source.user_id || source.uid || this.jobData.user_id || ''
				const buildPayload = info => ({
					admin_id: this.adminId || '', uid: uid, url: source.url || '',
					name: info.realname || info.username || info.name || source.to_chat_name || this.to_chat_name || '',
					school_name: info.academy_name || info.school_name || '',
					smajor: info.major_name || info.smajor || info.department || '',
					edu: info.highest_education || info.edu || info.education || info.degree || '',
					avatar: info.avatar || source.avatar || info.gender || source.gender || ''
				})
				const payload = buildPayload(source)
				if (payload.uid && payload.name && payload.school_name && payload.smajor && payload.edu) return success(payload, source)
				if (!uid) return this.$message.warning('未获取到简历所属学生信息')
				this.$util.post('v2/school_job/user_record_info_by_userid', { user_id: uid }, res => {
					if (Number(res.code) === 200 && res.data) return success(buildPayload(res.data), res.data)
					this.$message.error(res.msg || '')
				})
			},
			readResume(item, success) {
				if (!item || !item.url) return this.$message.warning('暂无可操作的简历')
				this.getResumeReadPayload(item, (payload, profile) => this.$axios.post('https://np.sx985.com/v2/readResume', Qs.stringify(payload), { headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + (localStorage.getItem('nextToken') || '') } }).then(res => {
					if (Number(res.data && res.data.code) === 200) return success && success(profile)
					this.resumeRechargeVisible = true
				}).catch(() => { this.resumeRechargeVisible = true }))
			},
			goResumeRecharge() { this.resumeRechargeVisible = false; this.$router.push({ path: '/resumeRecharge' }) },
			previewResume(item) {
				if (!item.url) return this.$message.warning('暂无可预览的简历')
				this.readResume(item, () => {
					const openPreview = url => {
						this.openResumePreview(url, item)
					}
					if (!this.isWordResume(item.url)) return openPreview(item.url)
					// this.$message.info('简历转换中')
					fetch(item.url).then(res => {
						if (!res.ok) throw new Error('Word简历下载失败')
						return res.blob()
					}).then(file => {
						const formData = new FormData()
						const fileName = decodeURIComponent(item.url.split('?')[0].split('/').pop() || 'resume.docx')
						formData.append('file', file, fileName)
						formData.append('fileName', fileName)
						return this.$axios.post('https://np.sx985.com/job/resume/convertPDF', formData, { headers: { Authorization: 'Bearer ' + (localStorage.getItem('nextToken') || '') } })
					}).then(res => {
						const pdfUrl = res.data && res.data.data && res.data.data.pdfUrl
						if (!pdfUrl) throw new Error((res.data && res.data.msg) || 'Word转PDF失败')
						openPreview(pdfUrl.replace(/^http:\/\//i, 'https://'))
					}).catch(error => {
						this.$message.error(error.message || 'Word转PDF失败')
					})
				})
			},
			openResumePreview(url, item) {
				this.resumePreview = { url: url, item: item, loading: true, error: '', pages: [], status: item.score_status || 1, statusSet: [2, 3, 4].includes(Number(item.score_status)) }
				this.resumePreviewVisible = true
				if (!this.resumePreviewHistoryPushed) {
					window.history.pushState({ resumePreview: true }, '')
					this.resumePreviewHistoryPushed = true
				}
				this.$nextTick(() => this.renderResumePdf(url))
			},
			closeResumePreview() {
				this.resumeStatusRequiredVisible = false
				this.resumePreviewCloseHandler = null
				this.resumePreview = { url: '', item: null, loading: false, error: '', pages: [], status: 0, statusSet: false }
				this.playPendingResumeFlyAnimation()
				if (this.resumePreviewHistoryPushed) {
					this.resumePreviewHistoryPushed = false
					window.history.back()
				}
			},
			requestCloseResumePreview(done) {
				if (this.resumePreview.statusSet) {
					if (typeof done === 'function') return done()
					this.resumePreviewVisible = false
					return
				}
				this.resumePreviewCloseHandler = typeof done === 'function' ? done : null
				this.resumeStatusRequiredVisible = true
			},
			handleResumePreviewPopstate() {
				if (!this.resumePreviewVisible) return
				window.history.pushState({ resumePreview: true }, '')
				this.resumePreviewHistoryPushed = true
				this.requestCloseResumePreview()
			},
			finishResumePreviewClose() {
				this.resumeStatusRequiredVisible = false
				if (this.resumePreviewCloseHandler) {
					const done = this.resumePreviewCloseHandler
					this.resumePreviewCloseHandler = null
					done()
					return
				}
				this.resumePreviewVisible = false
			},
			setResumePreviewStatus(type, closeAfterSet) {
				const item = this.resumePreview.item
				if (!item) return
				if (item.score_status === type || (this.resumePreview.statusSet && this.resumePreview.status === type)) {
					this.resumePreview.status = type
					this.resumePreview.statusSet = true
					if (closeAfterSet) this.finishResumePreviewClose()
					return
				}
				const card = document.getElementById('resume-card-' + item.id)
				const cardRect = card && card.getBoundingClientRect()
				this.reviewResume(item, type, applyListUpdate => {
					this.resumePreview.status = type
					this.resumePreview.statusSet = true
					if (cardRect) {
						this.pendingResumeFly = {
							item: item,
							type: type,
							startX: cardRect.left + cardRect.width / 2,
							startY: cardRect.top + cardRect.height / 2,
							applyListUpdate: applyListUpdate,
						}
					} else {
						applyListUpdate()
					}
					if (closeAfterSet || type !== 2) this.finishResumePreviewClose()
				}, true)
			},
			openResumePreviewChat() {
				const item = this.resumePreview.item
				if (!item) return
				if (this.pendingResumeFly) {
					this.pendingResumeFly.waitForChatClose = true
				}
				this.resumePreviewVisible = false
				this.$nextTick(() => this.openResumeChat(item))
			},
			playPendingResumeFlyAnimation() {
				const fly = this.pendingResumeFly
				if (!fly) return
				if (fly.waitForChatClose) return
				this.pendingResumeFly = null
				if (fly.skipAnimation || this.flyCard.show) {
					if (fly.applyListUpdate) fly.applyListUpdate()
					return
				}
				setTimeout(() => this.$nextTick(() => {
					const target = document.getElementById('resume-status-' + fly.type)
					if (!target) {
						if (fly.applyListUpdate) fly.applyListUpdate()
						return
					}
					const end = target.getBoundingClientRect()
					Object.assign(this.flyCard, { show: true, avatar: fly.item.avatar, name: fly.item.realname || fly.item.username || fly.item.name, userId: fly.item.user_id, gender: fly.item.gender, currentX: fly.startX, currentY: fly.startY, scale: 1, rotateX: 0, rotateY: 0, rotateZ: 0, opacity: 1 })
					const startTime = Date.now(), startX = fly.startX, startY = fly.startY, endX = end.left + end.width / 2, endY = end.top + end.height / 2, controlY = Math.min(startY, endY) - 230, direction = endX >= startX ? 1 : -1
					const animate = () => {
						const progress = Math.min((Date.now() - startTime) / 1100, 1), t = progress < .5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2, pop = Math.sin(progress * Math.PI)
						this.flyCard.currentX = Math.pow(1 - t, 2) * startX + 2 * (1 - t) * t * ((startX + endX) / 2) + Math.pow(t, 2) * endX
						this.flyCard.currentY = Math.pow(1 - t, 2) * startY + 2 * (1 - t) * t * controlY + Math.pow(t, 2) * endY
						this.flyCard.scale = .94 + pop * .34 - progress * .58; this.flyCard.rotateX = -18 * pop; this.flyCard.rotateY = direction * 24 * pop; this.flyCard.rotateZ = direction * (10 * pop - 8 * progress); this.flyCard.opacity = progress > .86 ? 1 - ((progress - .86) / .14) * .28 : 1; this.flyCard.shadow = '0 ' + Math.round(18 + pop * 36) + 'px 42px rgba(0,0,0,.3)'
						if (progress < 1) window.requestAnimationFrame(animate); else {
							this.flyCard.show = false
							if (fly.applyListUpdate) fly.applyListUpdate()
						}
					}
					window.requestAnimationFrame(animate)
				}), 500)
			},
			renderResumePdf(url) {
				pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker
				pdfjsLib.getDocument(url).promise.then(pdf => {
					const tasks = []
					for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
						tasks.push(pdf.getPage(pageNumber).then(page => {
							const viewport = page.getViewport({ scale: 1.45 })
							const canvas = document.createElement('canvas')
							canvas.width = viewport.width
							canvas.height = viewport.height
							return page.render({ canvasContext: canvas.getContext('2d'), viewport: viewport }).promise.then(() => canvas.toDataURL('image/png'))
						}))
					}
					return Promise.all(tasks)
				}).then(pages => {
					if (!this.resumePreviewVisible || this.resumePreview.url !== url) return
					this.resumePreview.pages = pages
					this.resumePreview.loading = false
				}).catch(error => {
					if (!this.resumePreviewVisible || this.resumePreview.url !== url) return
					this.resumePreview.loading = false
					this.resumePreview.error = error.message || '简历加载失败'
				})
			},
			viewDownloadResumeFile(item, optType, success) {
				if (!item || !item.id) return this.$message.warning('暂无可操作的简历')
				if (optType === 2) this.resumeDownloading = true
				this.$util.post('v2/school_job/viewDownloadFile', {
					admin_id: this.adminId,
					file_id: item.id,
					opt_type: optType
				}, (res) => {
					if (Number(res.code) === 0) {
						this.refreshResumeQuota()
						return success && success()
					}
					// this.$message.error(res.msg || '简历操作失败')
					if (optType === 2) this.resumeDownloading = false
				}, () => {
					if (optType === 2) this.resumeDownloading = false
					// this.$message.error('简历操作失败')
				})
			},
			getResumeDownloadName(item, profile) {
				const fileUrl = (item && item.url) || ''
				let urlName = ''
				try {
					urlName = decodeURIComponent(fileUrl.split('?')[0].split('/').pop() || '')
				} catch (e) {
					urlName = fileUrl.split('?')[0].split('/').pop() || ''
				}
				const extension = (urlName.match(/\.[^.]+$/) || [''])[0]
				const source = item || {}
				const info = profile || {}
				const name = source.realname || info.realname || source.username || info.username || ''
				const school = source.academy_name || info.academy_name || source.school_name || info.school_name || ''
				const major = source.major_name || info.major_name || source.smajor || info.smajor || ''
				return [name, school, major].filter(Boolean).join('-').replace(/[\\/:*?"<>|]/g, '_') + extension
			},
			saveResumeFile(item, profile) {
				fetch(item.url).then(res => {
					if (!res.ok) throw new Error('简历下载失败')
					return res.blob()
				}).then(blob => {
					const link = document.createElement('a')
					link.href = URL.createObjectURL(blob)
					link.download = this.getResumeDownloadName(item, profile)
					document.body.appendChild(link)
					link.click()
					document.body.removeChild(link)
					URL.revokeObjectURL(link.href)
				}).catch(error => {
					this.$message.error(error.message || '简历下载失败')
				}).finally(() => {
					this.resumeDownloading = false
				})
			},
			download(item){
				if (!item || !item.url) return this.$message.warning('暂无可下载的简历')
				this.readResume(item, profile => this.saveResumeFile(item, profile))
			},
			startFlyAnimation(item, type, index, event) {
				if (item.score_status === type || this.flyCard.show) return
				const start = event.currentTarget.getBoundingClientRect()
				const target = document.getElementById('resume-status-' + type)
				if (!target) return this.reviewResume(item, type)
				const end = target.getBoundingClientRect()
				Object.assign(this.flyCard, { show: true, avatar: item.avatar, name: item.realname || item.username || item.name, userId: item.user_id, gender: item.gender, currentX: start.left + start.width / 2, currentY: start.top + start.height / 2, scale: 1, rotateX: 0, rotateY: 0, rotateZ: 0, opacity: 1 })
				const startTime = Date.now(), startX = this.flyCard.currentX, startY = this.flyCard.currentY, endX = end.left + end.width / 2, endY = end.top + end.height / 2, controlY = Math.min(startY, endY) - 230, direction = endX >= startX ? 1 : -1
				const animate = () => {
					const progress = Math.min((Date.now() - startTime) / 1100, 1), t = progress < .5 ? 4 * progress * progress * progress : 1 - Math.pow(-2 * progress + 2, 3) / 2, pop = Math.sin(progress * Math.PI)
					this.flyCard.currentX = Math.pow(1 - t, 2) * startX + 2 * (1 - t) * t * ((startX + endX) / 2) + Math.pow(t, 2) * endX
					this.flyCard.currentY = Math.pow(1 - t, 2) * startY + 2 * (1 - t) * t * controlY + Math.pow(t, 2) * endY
					this.flyCard.scale = .94 + pop * .34 - progress * .58; this.flyCard.rotateX = -18 * pop; this.flyCard.rotateY = direction * 24 * pop; this.flyCard.rotateZ = direction * (10 * pop - 8 * progress); this.flyCard.opacity = progress > .86 ? 1 - ((progress - .86) / .14) * .28 : 1; this.flyCard.shadow = '0 ' + Math.round(18 + pop * 36) + 'px 42px rgba(0,0,0,.3)'
					if (progress < 1) window.requestAnimationFrame(animate); else { this.flyCard.show = false; this.reviewResume(item, type) }
				}
				window.requestAnimationFrame(animate)
			},
			isResumeStatusOperationFrequent(item) {
				const cacheKey = 'resumeStatusUpdateAt_' + (this.adminId || '') + '_' + item.id
				const lastUpdateAt = Number(localStorage.getItem(cacheKey) || 0)
				if (Date.now() - lastUpdateAt < 15000) {
					if (!this.resumeStatusFrequentMessage) {
						let message
						message = this.$message.warning({
							message: '您的操作太频繁了，请稍后再试',
							onClose: () => {
								if (this.resumeStatusFrequentMessage === message) this.resumeStatusFrequentMessage = null
							}
						})
						this.resumeStatusFrequentMessage = message
					}
					return true
				}
				localStorage.setItem(cacheKey, String(Date.now()))
				return false
			},
			reviewResume(item,type,success,deferListUpdate){
				if (this.isResumeStatusOperationFrequent(item)) return
				let abj = {
				    id: item.id,
				    score_status: type
				}
				this.$util.post(
					'v2/school_job/saveResumeScore', {
						...abj
					},
					(res) => {
						if(res.data==0){
							this.$message.success('操作成功');
							const updateList = () => {
								const oldStatus = item.score_status
								item.score_status = type
								this.updateResumeStatusCount(oldStatus, type)
								if (this.statusIndex !== 0) {
									const currentIndex = this.recordList.indexOf(item)
									if (currentIndex >= 0) this.recordList.splice(currentIndex, 1)
									this.total1 = Math.max(0, this.total1 - 1)
								}
							}
							if (!deferListUpdate) updateList()
							let altxt = type===2?"HR对你的简历很感兴趣，请及时关注聊天消息":type===3?"hi~你好，你的简历已收录我司人才库如有匹配岗位，会优先选择，敬请期待~":"非常感谢您投递本岗位，结合岗位需求和您的专业背景，暂时不太匹配，很遗憾本次未能合作，祝您早日找到心仪的工作。"
							let abj = {
							    source: 2,
							    user_id: item.user_id,
							    content: altxt,
							    type: 14,
							    admin_id: this.adminId,
							    job_id: item.job_id,
							    is_showtime: 1
							}
							this.postChat(abj, 0)
							success && success(updateList)
							
							console.log(abj)
						}
						
					}
				)
			},
			updateResumeStatusCount(oldStatus, newStatus) {
				const keys = { 1: 'num2', 2: 'num3', 3: 'num4', 4: 'num5' }
				if (keys[oldStatus]) this[keys[oldStatus]] = Math.max(0, this[keys[oldStatus]] - 1)
				if (keys[newStatus]) this[keys[newStatus]] += 1
			},
			openResumeChat(item) {
				this.openChatFrame({ job_id: item.job_id, admin_id: item.admin_id || this.adminId, user_id: item.user_id, to_chat_name: item.realname || item.username || item.name, to_chat_logo: item.avatar, to_gender: item.gender })
			},
			toSearch(){
				this.searchName1 = this.searchName
				this.currentpage = 1
				this.getResumeLibrary()
				this.getResumeLibraryTotal()
			},
			refreshResumePage() {
				if (this.resumeRefreshing) return
				const previousTotal = this.total1
				this.resumeRefreshing = true
				this.getResumeLibrary(() => {
					this.resumeRefreshing = false
					const newCount = Math.max(0, this.total1 - previousTotal)
					this.$message.success(newCount > 0 ? '新增' + newCount + '条简历' : '暂无新增简历')
				})
				this.getResumeLibraryTotal()
				this.getResumeQuota()
			},
			resetResumeSearch(){
				this.searchName = ''
				this.searchName1 = ''
				this.currentpage = 1
				this.getResumeLibrary()
				this.getResumeLibraryTotal()
			},
			getResumeLibraryTotal(){
				let jobs = []
				this.jobnameList.forEach((item,index,arr)=>{
					if(item.isSelect){
						if(index==0){
							 jobs = ''
						}else{
							jobs.push(item.name)
						}
					}
				})
				
				this.$util.post(
					"v2/school_job/getResumeLibraryTotal", {
						admin_id: this.schoolInfo.admin_id,
						job_title: jobs==''?'':JSON.stringify(jobs),
					},
					(res) => {
						console.log(res)
						let allnum = 0
						let cousronnum = 0
						
						let num1=0
						let num2=0
						let num3=0
						let num4=0
						let num5=0
						
						res.data.forEach(item => {
						    if (item.score_status === 0) {
						       num1 = item.count
						        allnum = item.count
						    }
						    if (item.score_status === 1) {
						        num2 = item.count
						        cousronnum += item.count
						    }
						    if (item.score_status === 2) {
						        num3 = item.count
						        cousronnum += item.count
						    }
						    if (item.score_status === 4) {
						        num5 = item.count
						        cousronnum += item.count
						    }
						})
						num4 = allnum - cousronnum
						this.num1=num1
						this.num2=num2
						this.num3=num3
						this.num4=num4
						this.num5=num5
					})
					
			},
			getJobNameList() {
				const cacheKey = 'messageManagementJobNames_' + this.schoolInfo.admin_id + '_' + this.schoolInfo.id
				const setJobNameList = (jobNames) => {
					this.jobnameList = [{ name: '不限', isSelect: true }].concat(jobNames.map(name => ({ name: name, isSelect: false })))
					this.updateJobTagsLayout()
				}
				try {
					const cache = JSON.parse(localStorage.getItem(cacheKey) || 'null')
					if (Array.isArray(cache)) {
						setJobNameList(cache)
						return
					}
				} catch (error) {
					localStorage.removeItem(cacheKey)
				}
				this.$util.post(
					'v2/pc/my_job_list', {
						admin_id: this.schoolInfo.admin_id,
						id: this.schoolInfo.id,
						page: 1,
						size: 1000,
					},
					(res) => {
						if (res.code !== 200 || !res.data || !Array.isArray(res.data.data)) return
						const jobNames = [...new Set(res.data.data.map(item => item.job_name).filter(Boolean))]
						localStorage.setItem(cacheKey, JSON.stringify(jobNames))
						setJobNameList(jobNames)
					}
				)
			},
			getResumeLibrary(callback){
				this.loading = true
				let searchName = this.searchName1.replace(/%/g, '');
				 let jobs = []
				this.jobnameList.forEach((item,index,arr)=>{
					if(item.isSelect){
						if(index==0){
							 jobs = ''
						}else{
							jobs.push(item.name)
						}
					}
				})
				this.statusIndex
				 // score_status 简历评分类型1：简历未读 2 感兴趣 3待定 4不合适
				this.$util.post(
					'v2/school_job/getResumeLibrary', {
						admin_id: this.adminId,
						keyword: searchName,
						job_title:jobs==''?'':JSON.stringify(jobs),
						score_status:Number(this.statusIndex),
						size:this.pageSizes1,
						page:this.currentpage
					},
					(res) => {
						if (res.code == 200) {
							console.log(res)
							if(res.data.data){
								this.recordList = res.data.data
							}else{
								this.recordList = []
							}
							this.total1 = Number(res.data.meta && res.data.meta.total) || 0
						}
						this.loading = false
						if (typeof callback === 'function') callback()
					}
				)
			},
			
			tabClick1(index) {
					this.jobMoreVisible = false
					this.jobnameList.forEach((item, index, arr) => {
						item.isSelect = false
					})
					this.jobnameList[index].isSelect = true
				
				// if (index == 0) {
				// 	this.jobnameList.forEach((item, index, arr) => {
				// 		item.isSelect = false
				// 	})
				// 	this.jobnameList[0].isSelect = true
				// } else {
				// 	this.jobnameList[0].isSelect = false
				// 	this.jobnameList[index].isSelect = !this.jobnameList[index].isSelect
				// 	let bol = false
				// 	this.jobnameList.forEach((item, index, arr) => {
				// 		if (item.isSelect == true) {
				// 			bol = true
				// 		}
				// 	})
				// 	if (!bol) {
				// 		this.jobnameList[0].isSelect = true
				// 	}
				// }
				
				
				console.log(this.jobnameList)
				if(this.searchName==''){
					this.searchName1 = ''
				}
				this.currentpage = 1
				this.getResumeLibrary()
				this.getResumeLibraryTotal()
				// if(this.searchName==''){
				// 	this.searchName1 = ''
				// }
			},
			resetResumeFilters() {
				this.jobMoreVisible = false
				this.jobnameList.forEach((item, index) => {
					item.isSelect = index === 0
				})
				this.statusIndex = 0
				if (this.searchName == '') {
					this.searchName1 = ''
				}
				this.currentpage = 1
				this.getResumeLibrary()
				this.getResumeLibraryTotal()
			},
			tabClick(index) {
				//console.log(tab.index)
				this.statusIndex = index
				if(this.searchName==''){
					this.searchName1 = ''
				}
				this.currentpage = 1
				this.getResumeLibrary()
				this.getResumeLibraryTotal()
				// this.currentPage = 1
				// this.getAllChatList()
			},
			typeString(str) {
				if (typeof str == 'string') {
					try {
						var obj = JSON.parse(str);
						// 等于这个条件说明就是JSON字符串 会返回true
						if (typeof obj == 'object' && obj) {
							return true;
						} else {
							//不是就返回false
							return false;
						}
					} catch (e) {
						return false;
					}
				}
				return false;
			},
			//获取生源列表
			getUserRecordList() {
				this.loading = true
				let url = ''
				if (!this.nextToken) {
					url = 'v2/school_job/user_record_list'
				} else {
					url = 'v2/pc/user_record_list'
				}
				this.$util.post(
					url, {
						page: this.currentpage,
						size: 12,
						...this.searchObj,

					},
					(res) => {
						if (res.code == 401) {
							console.log('请重新登录')
							// setTimeout(() => {
							// 	this.$router.replace({
							// 		path: '/login',
							// 	})
							// }, 10)
						}
						if (res.code == 200) {
							if (res.data.data) {
								let arr = res.data.data
								arr.forEach((item, index, arr) => {
									if (item.hobby && item.hobby !== '') {

										if (this.typeString(item.hobby)) {
											arr[index].hobbyList = (JSON.parse(item.hobby).s_by).splice(0, 3)
										} else {
											arr[index].hobbyList = item.hobby.split('、').splice(0, 3)
										}
									} else {
										arr[index].hobbyList = ['读书', '健身']
									}
									if (item.job_title) {
										if (this.typeString(item.job_title)) {
											arr[index].job_title = (JSON.parse(item.job_title)).toString()
										}
									}

								})
								this.recordList = arr

							} else {
								this.recordList = []
							}
							this.total1 = res.data.meta.total

						}
						this.loading = false
						console.log(this.recordList)
					}
				);
			},
			changeType(index) {
				this.isResumeDatabase = index
				this.$emit('update-message-management-navigation', index === 1)
				if (index == 1) this.updateJobTagsLayout()
				if (index == 1) {
					// this.positionIndex = -1
					// this.statusIndex = 0
					// this.currentpage = 1
					// this.getResumeLibrary()
					// this.getResumeLibraryTotal()
				}else{
					this.getAllChatList()
				}
			},
			toLogin() {
				this.$router.push({
					path: '/login',
					// query: {
					//   id: 1,
					// },
				})
			},
			deleteUsefulExpressions(index) {
				this.$confirm('确定删除该项', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let progress = JSON.parse(JSON.stringify(this.txtlist))
					progress.splice(index, 1)
					this.edit(0, progress)
				}).catch(() => {
								
				});
				
			},
			editUsefulExpressions(item, idx) {
				console.log(item)
				this.$prompt('请输入常用语', '常用语', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputType: 'textarea',
					inputPattern: /\S/,
					inputErrorMessage: '内容不能为空',
					inputValue: item,
					closeOnClickModal: false,
				}).then(({
					value
				}) => {
					let progress = JSON.parse(JSON.stringify(this.txtlist))
					progress[idx] = value
					this.edit(0, progress)
				}).catch(() => {

				});
			},
			addUsefulExpressions() {
				this.$prompt('请输入常用语', '常用语', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /\S/,
					inputType: 'textarea',
					inputErrorMessage: '内容不能为空',
					closeOnClickModal: false,
				}).then(({
					value
				}) => {
					let progress = [value,...this.txtlist]
					this.edit(0, progress)
				}).catch(() => {

				});
			},
			edit(id, progress) {
				this.$util.post(
					"v2/school_job/saveDialog", {
						admin_id: this.adminId,
						id: this.getDialogId,
						progress: JSON.stringify(progress)
					},
					(res) => {
						console.log(res)
						this.dialogList()
					}
				);
			},
			dialogList() {
				this.$util.post(
					"v2/school_job/getDialog", {
						admin_id: this.adminId,
					},
					(res) => {
						console.log(res)
						if (res.data && res.data != '') {
							this.getDialogId = res.data.id
							this.txtlist = JSON.parse(res.data.progress).reverse()
							// if(res.data.progress&&res.data.progress!='[]'){
							// 	this.txtlist = JSON.parse(res.data.progress)
							// }
							// else{
							// 	this.txtlist=['我看了您的相关经历，想和您聊聊，是否方便呢？', '您好，我想要一份您的附件简历。', '对不起，您暂不符合我们的岗位要求，期待以后有机会合作。']
							// }
						}
					}
				);
			},
			redact(item) {
				this.replyTxt += item.content
			},
			async handleLongPress(item, index) {
				const messageTime = new Date(item.created_at).getTime();
				const nowTime = new Date().getTime();
				const timeDiff = nowTime - messageTime;

				if (timeDiff <= 2 * 60 * 1000) { // 2分钟内
					let id = await this.getChatList1(index)
					if (item.id == '') {
						// recallChatMsg(id).then(res => {
						// 	this.newsList[index].is_recall = 1
						// })
						this.$util.post(
							'v2/school_job/recallChatMsg', {
								id: id
							},
							(res) => {
								this.sendWebSocketMessage({
									msgType: 'ChatMsg',
									source: 'Front',
									message: '我撤回了一条消息',
								})
								this.newsList[index].is_recall = 1
							})
					} else {
						this.$util.post(
							'v2/school_job/recallChatMsg', {
								id: item.id
							},
							(res) => {
								this.sendWebSocketMessage({
									msgType: 'ChatMsg',
									source: 'Front',
									message: '我撤回了一条消息',
								})
								this.newsList[index].is_recall = 1
							})
					}
				}
			},
			getChatList1(idx) {
				let obj = {
					source: 2,
					user_id: this.jobData.user_id,
					job_id: this.jobData.job_id || 0,
					admin_id: this.jobData.admin_id || this.adminId,
				}
				return new Promise((resolve, reject) => {
					this.$util.post(
						'v2/school_job/chat_list', {
							...obj,
							log_type: this.log_type,
						},
						(res) => {
							if (res.data.length > 0) {
								resolve(res.data[idx].id)
							} else {
								resolve('')
							}
						})
				})
			},
			eldialogOpen() {
				this.replyTxt = ''
				// clearInterval(this.interval)
				// this.interval = setInterval(() => {
				// 	console.log(1234)
				// 	this.getChatList(this.jobData.user_id, this.jobData.job_id, this.jobData.admin_id, this
				// 		.to_chat_name)
				// 	this.intervalCount++
				// 	if (this.intervalCount == 180) {
				// 		clearInterval(this.interval)
				// 	}
				// }, 10000)
			},
			popoverShow() {
				this.usefulExpressions = false
			},
			handleEnter() {},
			// wss://np.sx985.com/ws/imserver/69407&3&1@5151791&2&1
			join(uid) {
				//var username = document.getElementById('uid').value;
				//var url = urlPrefix + username;
				var url = `wss://np.sx985.com/ws/imserver/${this.adminId}&3&1@${uid}&2&1`
				// urlPrefix + '888&2&1@6666&1&1';
				let that = this
				this.ws = new WebSocket(url)
				this.ws.onmessage = function(res) {
					// console.log(res)
					try {
						let datas = JSON.parse(res.data)
						// that.replay = datas.content
						// that.messages.push(datas.content)

					} catch (e) {
						// console.log(e)
						//TODO handle the exception
					}

					// this.chatRead()
					// this.getChatMsgList()

					that.getChatList(that.jobData.user_id, that.jobData.job_id, that.jobData.admin_id, that
						.to_chat_name)


					// var ta = document.getElementById('responseText');
					// ta.value += event.data+"\r\n";
				}
				that.ws.onopen = function(event) {
					// console.log('WebSocket 连接已打开');
					that.reconnectAttempts = 0
					//console.log(event)
					// var ta = document.getElementById('responseText');
					// ta.value += "建立 websocket 连接... \r\n";
				}
				that.ws.onerror = function(event) {
					//console.log(event)
					// var ta = document.getElementById('responseText');
					// ta.value += "建立 websocket 连接... \r\n";
				}
				that.ws.onclose = function(event) {
					// console.log(event)
					if (event.reason != '用户主动关闭') { // 非正常关闭
						that.handleReconnection();
					}
					// this.join(item.user_id)
					//console.log(event)
					// var ta = document.getElementById('responseText');
					// ta.value += "用户["+username+"] 已经离开聊天室! \r\n";
					// ta.value += "关闭 websocket 连接. \r\n";
				}
			},
			handleReconnection() {
				if (this.reconnectAttempts < this.maxReconnectAttempts) {
					this.reconnectAttempts++;
					const delay = Math.min(1000 * this.reconnectAttempts, 5000);

					// console.log(`尝试第 ${this.reconnectAttempts} 次重连，${delay}ms后执行`);

					setTimeout(() => {
						this.join(this.jobData.user_id)
					}, delay);
				} else {
					// console.error(`已达到最大重连次数 ${this.maxReconnectAttempts}`);
				}
			},
			// 退出
			exit() {
				this.ws.close(1000, '用户主动关闭');
			},

			// // 发送消息
			//  send(message){
			//     // var message = document.getElementById('message').value;
			//     if(!window.WebSocket){return;}
			//     if(this.ws.readyState == WebSocket.OPEN){
			//         this.ws.send(message);
			//     }else{
			//         alert("WebSocket 连接没有建立成功！");
			//     }
			// },

			changeUsefulExpressions() {
				this.usefulExpressions = !this.usefulExpressions
			},
			handleClick(tab) {
				console.log(tab.index)
				this.tabIndex = tab.index * 1
				this.currentPage = 1
				this.getAllChatList()
				// if (tab.index == 0) {
					
				// } else {
				// 	this.getAllChatList()
				// 	// this.getmyJobList()
				// }
			},
			postUserList() {
				this.loading1 = true
				this.$util.post(
					'v2/school_job/post_user_list', {
						admin_id: this.adminId,
					},
					(result) => {
						//console.log(result)
						let postList = result.data.map((item, index, arr) => {
							return item.user_id
						})

						let obj = {
							source: 2,
							admin_id: this.adminId,
							page: 1,
							size: 99,
							status: 0,
							log_type: 2
						}
						// 76862 ||
						// all_chat_list
						this.$util.post(
							'v2/school_job/all_chat_list_new', {
								...obj,
							},
							(res) => {
								if (res.code === 0) {
									if (res.data.data) {
										let allChatList = []
										allChatList = res.data.data.filter((item, index, arr) => {
											return postList.indexOf(item.user_id) != -1
										})
										//console.log(allChatList)
										this.allChatList = allChatList.map((item) => {
											let c_txt = ''
											if (item.list) {
												c_txt = item.list[0].content
												// created_at = item.list[0].created_at.substring(11, 16)
												if (item.list[0].type === 3) {
													c_txt = item.list[0].content.substring(0, item.list[0]
														.content
														.indexOf('^>'))
												}
											}
											return {
												to_chat_name: item.to_chat_name,
												to_chat_logo: item.to_chat_logo,
												to_academy_name: item.to_academy_name,
												to_major_name: item.to_major_name,
												to_graduation_year: item.to_graduation_year,
												to_gender: item.to_gender,
												content: c_txt,
												created_at: item.list[0].created_at,
												status: item.list[0].status,
												admin_id: item.admin_id,
												type: item.list[0].type,
												job_id: item.list[0].job_id,
												user_id: item.user_id,
												source: item.list[0].source,
												is_recall: item.list[0].is_recall,
											}
										})
										this.total = res.data.total
										this.getUnreadMessageList()
									}
								}
								this.loading1 = false
							}
						)

					},
					() => {
						setTimeout(() => {
							this.$nextTick(() => {
								this.scrollToBottom()
							})
							this.loading = false
						}, 500)
					}
				)
			},
			goJobDetail1(job_id) {
				return new Promise((resolve, reject) => {
					this.$util.post(
						"v2/school_job/getJobInfo", {
							id: job_id,
						},
						(res) => {
							//console.log(res.data)
							if (res.code === 200) {
								let item = res.data
								if (item.salary_min > 99 || item.salary_max > 99) {
									item.salary_k = item.salary_min + '-' + item.salary_max + '/天'
								} else if (item.salary_min && item.salary_max) {
									item.salary_k = item.salary_min + '-' + item.salary_max + 'K'
								} else if (item.salary_min && !item.salary_max) {
									item.salary_k = item.salary_min + 'K+'
								} else if (!item.salary_min && item.salary_max) {
									item.salary_k = item.salary_max + 'K'
								} else if (!item.salary_min && !item.salary_max) {
									item.salary_k = '面议'
								} else {
									item.salary_k = '面议'
								}
								this.infoData = res.data
								if (res.data.company_info) {
									this.company_info = res.data.company_info
									if (res.data.company_info.feature) {
										res.data.company_info.feature = res.data.company_info.feature
											.replace(/,/g, '，').replace(/、/g, '，')
										this.company_info.feature = res.data.company_info.feature.split('，')
									} else {
										try {
											this.company_info.feature = (res.data.nature.split('，')).concat(
												res.data.scale.split('，'))
										} catch (e) {
											this.company_info.feature = []
											//TODO handle the exception
										}
									}
								}



								if (res.data.welfare) {
									let welfares = this.getSimpleText(res.data.welfare)
									welfares = welfares.replace(/、/g, ',').replace(/，/g, ',').replace(/;/g,
										',').replace(
										/ /g, ',')
									this.infoData.welfare = welfares.split(',')
								}
								if (res.data.highlights) {
									let highlights = this.getSimpleText(res.data.highlights)
									highlights = highlights.replace(/、/g, ',').replace(/，/g, ',').replace(
										/;/g, ',').replace(
										/ /g, ',')
									this.infoData.highlights = highlights.split(',').filter((item) => {
										return item
									})
								}

								if (res.data.work_freedom) {
									let work_freedom = this.getSimpleText(res.data.work_freedom)
									work_freedom = work_freedom.replace(/、/g, ',').replace(/，/g, ',')
										.replace(/;/g, ',')
										.replace(/ /g, ',')
									this.infoData.work_freedom = work_freedom.split(',')
								}
								if (res.data.job_desc.indexOf('table') > -1) {
									this.infoData.job_desc = res.data.job_desc
								} else {
									let aaaa = res.data.job_desc
										.replace(/<p>/gi, '<p style="text-align:;text-indent:20px;">')
										.replace(/<p([\s\w"=\/\.:;]+)((?:(style="[^"]+")))/gi, '^')
										.replace(/<br\s*\/?/gi, '^')
										.replace(/[\r\n]/g, '^>')
										.replace(/&nbsp;/gi, ' ')
										.replace(/nbsp;/gi, ' ')
										.replace(/ /g, '')
									aaaa = this.getSimpleText(aaaa)
									let bbb = aaaa.split('^>')
									//  && item.indexOf('其他描述')===-1 
									let are = bbb.filter(item => {
										return item && item !== '岗位详情'
									})
									let ary = []
									are.forEach((item, index) => {
										if (item) {
											item = item.replace(/\s+/g, '').replace(/\?/g, '')
											if (item) {
												if (item.indexOf("；") > -1) {
													item = item.replace(/；/g, '；~')
													ary = ary.concat(item.split('~'))
												} else if (item.indexOf("。") > -1) {
													item = item.replace(/。/g, '。~')
													ary = ary.concat(item.split('~'))
												} else if (item.length < 7) {
													if (index < are.length - 1) {
														if (are[index + 1].length < 7) {
															item = ''
														}
													}
													item = item.replace(/：/g, '').replace(/:/g, '')
														.replace(/【/g,
															'').replace(/】/g, '')
													ary.push(item)
												} else {
													ary.push(item)
												}
											}

										}
									})
									if (ary.length > 0) {
										if ((ary[0].indexOf("详情") === -1 || ary[0].indexOf("职责") == -1 ||
												ary[0].indexOf("岗位") === -1) && ary[0].length > 6) {
											this.showJobTitle = true
										}
									}
									// 
									this.infoData.job_deo = ''
									this.detailslist = ary.slice(0, 5)

								}
								let newJobData = {
									job_name: res.data.job_name,
									job_desc: this.infoData.job_desc,
									detailslist: this.detailslist,
									freedomlist: this.infoData.work_freedom,
									highlist: this.infoData.highlights,
									feature: this.company_info.feature,
									salary_k: item.salary_k,
									education: res.data.education,
									experience: res.data.experience,
									company_name: res.data.company_name || '',
									scale: res.data.scale || '',
									job_id: this.jobData.job_id || this.jobId || 0,
									created_at: this.showTime1()

								}
								resolve(newJobData)
							} else {
								reject('');
							}
						}
					);
				})
			},
			getSimpleText(html) {
				const re1 = new RegExp("<.+?>", "g"); // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
				const arrEntities = {
					'lt': '<',
					'gt': '>',
					'amp': '&',
					'quot': '"',
					'ldquo': '“',
					'mdash': '—',
					"rdquo": '”'
				};
				return html.replace(re1, '').replace(/&(lt|gt|amp|quot|ldquo|mdash|rdquo);/ig, function(all, t) {
					return arrEntities[t];
				});
			},
			showTime1() {
				let now = new Date();
				let year = now.getFullYear();
				let month = now.getMonth() + 1;
				if (month < 10) {
					month = '0' + month
				}
				let day = now.getDate();
				if (day < 10) {
					day = '0' + day
				}
				let hour = now.getHours();
				let minute = now.getMinutes();
				let second = now.getSeconds();
				return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
			},
			getChatList(userid, job_id, admin_id, to_chat_name) {
				this.loading = true
				let obj = {
					source: 2,
					user_id: userid,
					job_id: job_id || 0,
					admin_id: admin_id || this.adminId,
				}
				this.$util.post(
					'v2/school_job/chat_list', {
						...obj,
						log_type: this.log_type,
					},
					(res) => {
						if (res.data.length > 0) {
							res.data.forEach(async (item, index) => {
								if (index === 0 && item.source === 1) {
									this.isBtoC = false
								}
								if (item.type === 4) {
									try {
										item.content = JSON.parse(item.content)
									} catch (error) {
										item.content = await this.goJobDetail1(job_id)
										//TODO handle the exception
									}
									// this.jobTitle = item.content.job_name

								}
								if (item.type === 6) {
									item.content = JSON.parse(item.content)
								}
								if (item.type === 8 || item.type === 9) {
									item.content = JSON.parse(item.content)
								}
								if (item.type === 2) {
									item.url_list = JSON.parse(item.url)
								}
								if (item.type === 3) {
									item.file_name = item.content.split('^>')[0]
									item.file_size = item.content.split('^>')[1]
								}
								if (item.type === 1) {
									if (item.content.indexOf('我的微信号码是') > -1 || item.content.indexOf(
											'抱歉我不能提供我的微信号') > -1) {
										this.isSendWeChat = true
									}
								}
								if (item.type === 7) {
									item.content = JSON.parse(item.url)
								}
							})
							this.tel = res.data[0].to_chat_tel
							this.msg_id = res.data[0].id
							// if()
							this.sendUserId = res.data[0].user_id
							this.to_chat_logo = res.data[0].to_chat_logo || ''
							this.to_chat_email = res.data[0].to_chat_email
							this.to_chat_wechat = res.data[0].to_chat_wechat
							this.to_user_id = res.data[0].user_id
							this.to_chat_name = to_chat_name //.substring(0,1)

							this.newsList = res.data

							this.todiv = 'to_bottom'
						}
						setTimeout(() => {
							this.$nextTick(() => {
								this.loading = false
								this.scrollToBottom()
							})
						}, 500)
					},
					() => {
						
					}
				)
			},
			selectExp(item) {
				this.replyTxt = this.replyTxt + item
			},
			handleChange(file, fileList) {
				console.log(file)
				if (file.response) {
					let fileNameUrl = [file.name, file.response.data.fileUrl, file.size]
					let abj = {
						source: 2,
						user_id: this.jobData.user_id,
						url: JSON.stringify(fileNameUrl),
						type: 7,
						admin_id: this.jobData.admin_id,
						job_id: this.jobData.job_id,
						is_showtime: this.needSendTIme || 0,
					}
					let content_ary = [{
						is_read: 0,
						source: 2,
						status: 2,
						type: 7,
						url: JSON.stringify(fileNameUrl),
						content: fileNameUrl,
						is_showtime: this.needSendTIme || 0,
						created_at: this.getSimpleDate(),
					}, ]
					this.newsList = this.newsList.concat(content_ary)

					this.needSendTIme = 0
					setTimeout(() => {
						this.$forceUpdate()
						this.$nextTick(() => {
							this.scrollToBottom()
							this.visible2 = false
						})
					}, 100)
					this.postChat(abj)
				}
			},


			userAsk(txt) {
				// if (txt) {
				//     this.replyTxt = txt
				// }
				this.replyTxt = this.replyTxt.trim()
				if (!this.replyTxt && !txt) {
					this.$message.error('请输入内容')
					return
				}
				// this.showEmote = false
				// this.show2 = false
				// this.show1 = false
				// this.show4 = false
				// this.todiv = 'to_bottom'
				let abj = {
					source: 2,
					user_id: this.jobData.user_id,
					content: txt || this.replyTxt,
					type: 1,
					admin_id: this.jobData.admin_id,
					job_id: this.jobData.job_id,
					is_showtime: this.needSendTIme || 0,
				}

				let content_ary = [{
					content: txt || this.replyTxt,
					is_read: 0,
					source: 2,
					status: 2,
					type: 1,
					user_id: this.jobData.user_id,
					is_showtime: this.needSendTIme || 0,
					created_at: this.getSimpleDate(),
				}, ]

				this.newsList = this.newsList.concat(content_ary)
				let t_str = txt ? 1 : 0

				this.postChat(abj, t_str)

				this.schoolJobSend(4)
				// this.getAllChatList()
				this.usefulExpressions = false

				setTimeout(() => {
					this.$forceUpdate()
					this.$nextTick(() => {
						this.scrollToBottom()
						this.visible2 = false
					})
				}, 10)
			},


			goJobDetail(item) {
				this.$util.post(
					"v2/school_job/getJobInfo", {
						id: item.job_id,
					},
					(res) => {
						//console.log(res)
						if (res.data) {
							this.$router.push({
								path: '/addPosition',
								query: {
									id: item.job_id,
								},
							})
						} else {
							this.$message.error('该职位已下架');
						}
					}
				);


				// this.$uniapp.goPage(`/pages/recruit/jobdetail?id=${item.job_id}`)
			},
			// 关闭连接
			closeWebSocket() {
				if (this.ws) {
					this.ws.close({
						code: 1000,
						reason: '用户主动关闭',
					})
				}
			},
			// 发送消息
			sendWebSocketMessage(message) {
				let that = this

				return new Promise((resolve, reject) => {
					if (!that.ws || that.ws.readyState !== 1) {
						reject('WebSocket 未连接')
						return
					}
					// console.log(message)
					that.ws.send(JSON.stringify(message))
					// that.ws.send({
					//   data: '11111'|| JSON.stringify(message),
					//   success: (rrr) => {
					//
					//     resolve()
					//   },
					//   fail: (err)=> {
					//
					//      reject(err)
					//   }
					// });
				})
			},
			async send(obj, type) {
				try {
					await this.sendWebSocketMessage({
						msgType: type || 'ChatMsg',
						source: 'Front',
						message: JSON.stringify(obj),
					})

					// this.$uniapp.toast('消息已发送');
				} catch (err) {
					// this.$uniapp.toast('发送失败: ');
				}
			},
			schoolJobSend() {
				this.$util.post(
					'v2/school_job/send', {
						admin_id: this.jobData.admin_id,
						user_id: this.jobData.user_id,
					},
					(res) => {
						if (res.code == 1) {
							// localStorage.setItem("token", res.data.token);
							// this.$router.push({
							// 	path: "/main",
							// 	// query: {
							// 	//   id: 1,
							// 	// },
							// });
						}
					}
				)
				// schoolJobSend(this.jobData.admin_id, this.jobData.user_id, type).then(() => {})
			},
			scrollToBottom() {
				const container = this.$refs.scrollContainer
				if (container) {
					container.scrollTo({
						top: container.scrollHeight + 20, // 滚动到最底部
						behavior: 'smooth', // 平滑滚动
					})
				}
			},
			playAudio(audioUr, index) {
				if (this.audioPlayerIndex == '') {
					let audio = 'audio' + index
					this.$refs[audio][0].play()
					this.audioPlayerUrl = audioUr
					this.audioPlayerIndex = index
					let that = this
					that.$refs[audio][0].addEventListener('ended', function() {
						that.audioPlayerUrl = ''
					}, false);
				} else {
					let audio1 = 'audio' + this.audioPlayerIndex
					this.$refs[audio1][0].play()

					let audio = 'audio' + index
					this.$refs[audio][0].pause()
					this.audioPlayerUrl = ''

					// this.audioPlayerUrl = audioUr
					this.audioPlayerIndex = ''
				}
			},
			getUnreadMessageList() {
				if (!this.adminId) return
				// this.$util.post('v2/school_job/get_box_num2', {
				// 	admin_id: this.adminId,
				// 	source: 2,
				// }, (res) => {
				// 	if (res.code !== 0 && res.code !== 200) return
				// 	const unreadMessageMap = {}
				// 	const unReadList = res.data && Array.isArray(res.data.un_read) ? res.data.un_read : []
				// 	unReadList.forEach(item => {
				// 		if (Number(item.cnt) > 0) unreadMessageMap[item.user_id] = Number(item.cnt)
				// 	})
				// 	this.unreadMessageMap = unreadMessageMap
				// })
			},
			getUnreadMessageCount(userId) {
				return Number(this.unreadMessageMap[userId]) || 0
			},
			chatSignalRead(userid) {
				if (!this.adminId) {
					return
				}
				let obj = {
					admin_id: this.adminId,
					source: 2,
					user_id: userid,
				}
			this.$util.post(
				'v2/school_job/is_read2', {
						...obj,
					},
					(res) => {
						if (res.code === 0) {
							this.$delete(this.unreadMessageMap, userid)
							this.$emit('update-unread-message-count')
							// uni.removeTabBarBadge({
							//     index: 3
							// })
						}
					}
				)
			},
			chatRead() {
				if (!this.adminId) {
					return
				}
				// let obj = {
				// 	source: 2,
				// 	admin_id: this.adminId,
				// }
				// this.$util.post(
				// 	'v2/school_job/is_read', {
				// 		...obj,
				// 	},
				// 	(res) => {
				// 		if (res.code === 0) {
				// 			this.$emit('update-unread-message-count')
				// 			// uni.removeTabBarBadge({
				// 			//     index: 3
				// 			// })
				// 		}
				// 	}
				// )//原先读取接口
				// chatRead(obj).then((res) => {
				// 	if (res.code === 0) {
				// 		// uni.removeTabBarBadge({
				// 		//     index: 3
				// 		// })
				// 	}
				// })
			},
			beforeAvatarUpload1() {
				this.visible2 = false
			},
			openLocation() {
				window.open('https://map.qq.com/')
			},
			getSimpleDate() {
				let date = new Date()
				var y = date.getFullYear()
				var m = date.getMonth() + 1
				m = m < 10 ? '0' + m : m
				var d = date.getDate()
				d = d < 10 ? '0' + d : d
				var h = date.getHours()
				h = h < 10 ? '0' + h : h
				var minute = date.getMinutes()
				minute = minute < 10 ? '0' + minute : minute
				var s = date.getSeconds()
				s = s < 10 ? '0' + s : s
				return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s
			},
			handleAvatarSuccess1(res) {
				this.lineImg = res.data.fileUrl

				if (this.lineImg) {
					let imageList = [this.lineImg]

					let abj = {
						source: 2,
						user_id: this.jobData.user_id,
						url: JSON.stringify(imageList),
						type: 2,
						admin_id: this.jobData.admin_id,
						job_id: this.jobData.job_id,
						is_showtime: this.needSendTIme || 0,
					}
					let content_ary = [{
						is_read: 0,
						source: 2,
						status: 2,
						type: 2,
						url: JSON.stringify(imageList),
						is_showtime: this.needSendTIme || 0,
						created_at: this.getSimpleDate(),
					}, ]
					this.newsList = this.newsList.concat(content_ary)

					setTimeout(() => {
						this.$forceUpdate()
						this.needSendTIme = 0
						this.$nextTick(() => {
							this.scrollToBottom()
						})
					}, 100)

					// this.visible2 = false
					this.postChat(abj)
				}
			},
			postChat(abj, type) {
				if (this.needSendTIme) {
					abj.is_showtime = 1
				}
				// console.log(123)
				this.send(abj)
				this.$util.post(
					'v2/school_job/chat', {
						log_type: this.log_type,
						...abj,
					},
					() => {
						this.getChatList(this.jobData.user_id, this.jobData.job_id, this.jobData.admin_id, this
							.to_chat_name)
						if (!type) {
							this.replyTxt = ''
						}
						this.lineHeight = 24
						this.showEmote = false
						this.needSendTIme = 0
					}
				)
				// postChat(abj, this.log_type).then(() => {

				// })
			},
			getAllChatList() {
				this.loading1 = true
				let obj = {
					source: 2,
					admin_id: this.adminId,
					page: this.currentPage,
					size: 6,
					status: this.tabIndex,
					log_type: 2
				}
				// 76862 ||
				// all_chat_list
				this.$util.post(
					'v2/school_job/all_chat_list_new', {
						...obj,
					},
					(res) => {
						if (res.code === 0) {
							if (res.data.data) {
								this.allChatList = res.data.data.map((item) => {
									let c_txt = ''
									if (item.list) {
										c_txt = item.list[0].content
										// created_at = item.list[0].created_at.substring(11, 16)
										if (item.list[0].type === 3) {
											c_txt = item.list[0].content.substring(0, item.list[0].content
												.indexOf('^>'))
										}
									}
									return {
										to_chat_name: item.to_chat_name,
										to_chat_logo: item.to_chat_logo,
										to_academy_name: item.to_academy_name,
										to_major_name: item.to_major_name,
										to_graduation_year: item.to_graduation_year,
											to_gender: item.to_gender,
										content: c_txt,
										created_at: item.list[0].created_at,
										status: item.list[0].status,
										admin_id: item.admin_id,
										type: item.list[0].type,
										job_id: item.list[0].job_id,
										user_id: item.user_id,
										source: item.list[0].source,
										is_recall: item.list[0].is_recall,
									}
								})
								this.total = res.data.total
								this.getUnreadMessageList()
							}
						}
						this.loading1 = false
					}
				)
			},

			currentChange1(page) {
				this.currentPage = page
				this.getAllChatList()
				// this.getEnterpriseList()
			},
			previousChatPage() {
				if (this.currentPage > 1) {
					this.currentPage--
					this.getAllChatList()
				}
			},
			openImg(i) {
				this.dialogVisibleImg = true
				this.dialogImageUrl = i
			},
			openPdf(item, type) {
				if (item.type === 3) {
                        window.open(item.url, '_blank')
					// this.readResume(item, () => window.open(item.url, '_blank'))  //暂时注释
				} else if (type) {
					window.open(item.content[1], '_blank')
				} else {
					window.open(item.url, '_blank')
				}
			},
			nextChatPage() {
				if (!this.isNextPage) {
					this.currentPage++
					this.getAllChatList()
				}
			},
			selectImg() {},
			uploadPdf() {},

			// openChatFrame() {
			//   this.dialogVisible = true
			// },
			openChatFrame(item) {
				this.needSendTIme = 1
				this.dialogVisible = true
				this.jobData.job_id = item.job_id
				this.jobData.admin_id = item.admin_id
				this.jobData.user_id = item.user_id
				this.to_chat_name = item.to_chat_name
				this.to_chat_logo = item.to_chat_logo
				this.to_chat_gender = item.to_gender
				this.join(item.user_id)
				this.getChatList(item.user_id, item.job_id, item.admin_id, item.to_chat_name)
				this.chatSignalRead(item.user_id)
				return

				// this.$uniapp.goPage(
				// 	`/pages/recruit/communicate?user_id=${item.user_id}&job_id=${item.job_id}&admin_id=${this.adminId}&userName=${item.to_chat_name}`
				// 	)
			},
			closeElDialog() {
				if (this.ws) {
					this.exit()
				}
				this.dialogVisible = false
				this.usefulExpressions = false
				if (this.audioPlayerIndex != '') {
					let audio1 = 'audio' + this.audioPlayerIndex
					this.$refs[audio1][0].pause()
				}

				this.loading = true
				this.to_chat_name = ''
				if (this.isAlreadyCommunicated == 2) {
					this.postUserList()
				} else {
					this.getAllChatList()
				}

				clearInterval(this.interval)
				// this.closeWebSocket()
			},
			handleChatDialogClosed() {
				// this.closeElDialog()
				if (this.pendingResumeFly && this.pendingResumeFly.waitForChatClose) {
					this.pendingResumeFly.waitForChatClose = false
					this.playPendingResumeFlyAnimation()
				}
			},
			sureWechat() {},

			currentChange(page) {

				this.currentpage = page
				// this.getEnterpriseList()
				this.getResumeLibrary()
			},
			previousPage() {
				if (this.currentpage > 1) {
					this.currentpage--
					this.getResumeLibrary()
				}
			},
			nextPage() {
				if (!this.isNextPage1) {
					this.currentpage++
					this.getResumeLibrary()
				}
			},

		},
		components: {
			// chatView
			studentAvatar,
		},
	}
</script>
<style>
	#messageManageBox .el-textarea__inner {
		min-height: 75px !important;
	}

	#messageManageBox .el-dialog {
		background: initial;
		box-shadow: initial;
		width: 465px !important;
		margin-top: 1vh !important;
	}

	#messageManageBox .el-textarea__inner {
		resize: none !important;
		/* border: none; */
		/* background: #F4F4F4 !important; */
		height: 120px !important;
	}

	#messageManageBox .avatar-uploader1 .el-upload {
		border: none;
	}

	#messageManageBox .el-dialog {
		margin: 0 auto 30px;
	}

	.resume-preview-dialog.el-dialog {
		width: 660px !important;
		margin-top: 10vh !important;
		border-radius: 10px;
		background: #fff !important;
		box-shadow: none !important;
		overflow: hidden;
        height:96vh !important;
	}

	.resume-preview-dialog .el-dialog__header,
	.resume-preview-dialog .el-dialog__body {
		padding: 0;
	}

	.resume-preview-modal { background: #fff; }

	.resume-preview-header {
		height: 64px;
		display: flex;
		align-items: center;
		padding: 0 20px 0 24px;
		box-sizing: border-box;
	}

	.resume-preview-title {
		display: flex;
		align-items: center;
		font-size: 18px;
		font-weight: 600;
		color: #1f2937;
	}

	.resume-preview-title span {
		width: 5px;
		height: 18px;
		margin-right: 8px;
		border-radius: 3px;
		background: #2f45e8;
	}

	.resume-preview-download {
		margin-left: auto;
		margin-right: 28px;
		font-size: 15px;
		color: #1677ff;
		cursor: pointer;
	}

	.resume-preview-close {
		font-size: 22px;
		color: #111;
		cursor: pointer;
	}

	.resume-preview-body {
		height: calc(98vh - 152px);
		margin: 0 32px;
		border: 2px solid #d7dbe1;
		border-radius: 10px;
		overflow-y: auto;
		background: #f8f9fb;
	}

	.resume-preview-pages img {
		display: block;
		width: 100%;
		height: auto;
		background: #fff;
	}

	.resume-preview-error {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		font-size: 14px;
		color: #909399;
	}

	.resume-preview-actions {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 76px;
		gap: 20px;
		padding: 0 30px;
		box-sizing: border-box;
	}

	.resume-preview-actions > .resume-preview-status {
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 1;
		height: 55px;
		border: 2px solid;
		border-radius: 14px;
		font-size: 17px;
		font-weight: 600;
		cursor: pointer;
		box-sizing: border-box;
	}

	.resume-preview-status i {
		margin-right: 7px;
		font-size: 26px;
		font-weight: 600;
	}

	.resume-preview-status-interested { color: #427a20; border-color: #badf8d !important; background: #eff8e4; }
	.resume-preview-status-pending { color: #915a16; border-color: #ffc76f !important; background: #fff4e2; }
	.resume-preview-status-unsuitable { color: #a23131; border-color: #ffc2c2 !important; background: #fff0f0; }
	.resume-preview-status.is-selected { box-shadow: inset 0 0 0 1px currentColor; }
	.resume-preview-status.is-disabled { color: #b8bcc4; border-color: #e5e7eb !important; background: #f5f6f8; cursor: not-allowed; }
	.resume-preview-status.is-disabled i { color: #b8bcc4; }

	.resume-preview-actions > .resume-preview-chat {
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 1;
		min-width: 0;
		height: 55px;
		padding: 0;
		box-sizing: border-box;
		border-radius: 14px;
		background: #1677ff;
		font-size: 17px;
		font-weight: 600;
		color: #fff;
		cursor: pointer;
	}

	.resume-status-required-dialog.el-dialog { margin-top: 50vh !important; transform: translateY(-50%); border-radius:10px;}
	.resume-recharge-reminder.el-dialog { margin-top: 50vh !important; transform: translateY(-50%); border-radius: 12px; overflow: hidden; }
	.resume-recharge-reminder .el-dialog__header { padding: 18px 24px; border-bottom: 1px solid #ebeef5; }
	.resume-recharge-reminder .el-dialog__title { color: #222; font-size: 18px; font-weight: 700; }
	.resume-recharge-reminder .el-dialog__body { padding: 54px 24px 34px; text-align: center; color: #30343b; font-size: 18px; }
	.resume-recharge-reminder .el-dialog__footer { padding: 0 0 30px; text-align: center; }
	.resume-recharge-reminder__footer .el-button { width: 110px; height: 40px; margin: 0 6px; font-size: 15px; }
	.resume-recharge-reminder__footer .el-button:first-child { color: #5f6368; border-color: #cfe5ff; background: #edf7ff; }
	.resume-status-required-dialog .el-dialog__body { padding: 32px 36px 36px; background: #fff;border-radius:10px; }
	.resume-status-required-title { font-size: 20px; font-weight: 600; color: #1f2937; text-align: center; }
	.resume-status-required-name { margin-top: 12px; color: #606266; font-size: 16px; text-align: center; }
	.resume-status-required-actions { display: flex; justify-content: space-between; margin-top: 32px; }
	.resume-status-required-actions > div { display: flex; align-items: center; color: #606266; cursor: pointer; font-size: 17px; }
	.resume-status-required-actions i { margin-right: 6px; color: #c7ccd3; font-size: 26px; }
	.resume-status-required-actions .is-selected,
	.resume-status-required-actions .is-selected i { color: #1685f5; }

	.resume-job-more-popper {
		max-width: 480px;
	}

	.resume-job-more-popper .job-more-list {
		display: flex;
		flex-wrap: wrap;
		gap: 12px 16px;
		font-size: 14px;
	}

	.resume-job-more-popper .job-more-list > div {
		cursor: pointer;
	}
.message-unread-dot {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border: 1px solid #ffffff;
  border-radius: 8px;
  background: #f56c6c;
  box-sizing: border-box;
  color: #ffffff;
  font-size: 11px;
  line-height: 14px;
  text-align: center;
}
</style>
<style lang="less" scoped>
	.container {
		width: 100%;
		padding: 0 27px;

		.headerContainer {
			width: 100%;
			padding: 20px 0 0 0;
			// border-bottom: 1px solid #EEEEEE;
			display: flex;
			align-items: center;
			// margin-bottom: 25px;

			.title {
				font-weight: bold;
				font-size: 16px;
				color: #333;
			}

			.stateContainer {
				margin-bottom: 30px;

				.messageTabs {
					display: flex;
					align-items: center;
					justify-content: space-between;

					.el-tabs {
						flex: 1;
					}
				}
		}

		.message-page-header {
			box-sizing: border-box;
			height: 60px;
			padding-top: 20px;
			align-items: flex-start !important;
		}

		.message-page-tab {
			display: flex;
			align-items: center;
			flex-direction: column;
			height: 40px;
			margin-right: 24px;
			cursor: pointer;
			box-sizing: border-box;
		}

		.message-page-tab .title {
			line-height: 20px;
			white-space: nowrap;
            font-weight:400;
		}

		.message-page-tab-indicator {
			width: 20px;
			height: 4px;
			margin-top: 6px;
			border-radius: 2px;
			background: #1e40af;
			opacity: 0;
			transition: opacity .15s ease;
		}

		.message-page-tab.is-active .message-page-tab-indicator {
			opacity: 1;
		}
        .message-page-tab.is-active .title{
            font-weight:bold;
        }
	}

		.list {
			// padding: 0 40px;
		}

		.listContainer {
			background: #fbfdff;
			// border: 1px solid #E5E5E5;
			// border-left: 1px solid #e5e5e5;
			// border-right: 1px solid #e5e5e5;
			// border-top: 1px solid #e5e5e5;
			width: 100%;
			min-width: 850px;
			// min-height: 600px;

			.item {
				min-width: 830px;
				border-bottom: 1px solid #e8eaf7;
				padding: 20px 30px;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.left {
					flex: 1;
					display: flex;
					align-items: center;

					.logo {
						font-size: 0;
						position: relative;
						margin-right: 30px;

						img {
							width: 57px;
							height: 57px;
							border-radius: 50%;
							background: #4f8ff0;
						}

						div {
							position: absolute;
							top: 0;
							right: 0;
							padding: 0px 5px;
							background: #ff5560;
							border-radius: 50%;

							font-weight: 400;
							font-size: 14px;
							color: #ffffff;
						}
					}

					.center {
						flex: 1;
						margin-right: 50px;

						.nameContainer {
							display: flex;
							align-items: center;
							margin-bottom: 10px;

							.name {
								font-weight: 500;
								font-size: 16px;
								color: #333;
								margin-right: 17px;
							}

							.tag {
								font-weight: 400;
								font-size: 12px;
								color: #999;
							}
						}

						.msg {
							min-width: 415px;
							min-width: 413px;
							font-weight: 400;
							font-size: 14px;
							color: #333;
							word-break: break-all;
						}
					}

					.time {
						width: 160px;
						font-weight: 400;
						font-size: 14px;
						color: #333;
					}
				}

				.right {
					width: 96px;
					height: 37px;
					background: #4f8ff0;
					border-radius: 5px;

					text-align: center;
					line-height: 37px;
					font-weight: bold;
					font-size: 14px;
					color: #ffffff;
				}
			}
		}
	}



	.elDialog {
		position: relative;
		font-size: 0;

		.main {
			box-sizing: border-box;
			padding: 0 0 0 0;
			background: #ffffff;
			border-radius: 10px;

			.userName {
				padding: 20px 20px;
				font-weight: bold;
				font-size: 16px;
				color: #333;
				text-align: left;
			}

			.msgList {
				padding: 50px 25px 0 25px;
				background: #f7f9ff;
				height: 512px;
				overflow-y: scroll;

				.item {
					margin-bottom: 40px;
				}

				.left {
					display: flex;
					align-items: flex-start;
					justify-content: flex-start;

					.userAvatar {
						font-size: 0;
						margin-right: 13px;

						img {
							width: 40px;
							height: 40px;
							border-radius: 5px;
							background: #4f8ff0;
						}
					}

					.typeContainer {
						max-width: 304px;
						background: #ffffff;
						border-radius: 10px;
						padding: 10px 15px;

						.card {
							width: 274px;

							.cardHeader {
								display: flex;
								align-items: center;
								justify-content: space-between;
								margin-bottom: 10px;

								.name {
									font-weight: 500;
									font-size: 16px;
									color: #333333;
								}

								.compensation {
									font-weight: 500;
									font-size: 16px;
									color: #fcad00;
								}
							}

							.other {
								font-weight: 500;
								font-size: 14px;
								color: #999;
								margin-bottom: 10px;
							}

							.tags {
								display: flex;
								align-items: center;
								margin-bottom: 10px;

								.tagsItem {
									padding: 2px 3px;
									background: #f7f7f7;
									border-radius: 5px;
									font-weight: 500;
									font-size: 12px;
									color: #999;
									margin-right: 5px;
								}
							}

							.introduce {
								font-weight: 500;
								font-size: 14px;
								color: #999;
								word-break: break-all;
							}
						}

						.text {
							font-weight: 500;
							font-size: 16px;
							color: #333;
						}

						.img {
							font-size: 0;

							img {
								max-width: 304px;
								background: #4f8ff0;
							}
						}
					}
				}

				.right {
					display: flex;
					align-items: flex-start;
					justify-content: flex-end;

					.userAvatar {
						font-size: 0;

						img {
							width: 40px;
							height: 40px;
							border-radius: 5px;
							background: #4f8ff0;
						}
					}

					.typeContainer {
						max-width: 304px;
						background: #ffffff;
						border-radius: 10px;
						padding: 10px 15px;
						margin-right: 13px;

						.card {
							width: 274px;

							.cardHeader {
								display: flex;
								align-items: center;
								justify-content: space-between;
								margin-bottom: 10px;

								.name {
									font-weight: 500;
									font-size: 16px;
									color: #333333;
								}

								.compensation {
									font-weight: 500;
									font-size: 16px;
									color: #fcad00;
								}
							}

							.other {
								font-weight: 500;
								font-size: 14px;
								color: #999;
								margin-bottom: 10px;
							}

							.tags {
								display: flex;
								align-items: center;
								margin-bottom: 10px;

								.tagsItem {
									padding: 2px 3px;
									background: #f7f7f7;
									border-radius: 5px;
									font-weight: 500;
									font-size: 12px;
									color: #999;
								}
							}

							.introduce {
								font-weight: 500;
								font-size: 14px;
								color: #999;
								word-break: break-all;
							}
						}

						.text {
							font-weight: 500;
							font-size: 16px;
							color: #222222;
						}

						.img {
							font-size: 0;

							img {
								max-width: 304px;
								background: #4f8ff0;
							}
						}
					}
				}
			}
		}

		.chartTool {
			width: 100%;
			height: 50px;
			display: flex;
			align-items: center;
			padding: 0 10px;

			.usefulExpressionsBtn {
				width: 66px;
				height: 30px;
				background: #dbeafe;
				border-radius: 5px;

				text-align: center;
				line-height: 30px;

				font-weight: 500;
				font-size: 14px;
				color: #4f8ff0;
				cursor: pointer;
				margin-right: 10px;


			}

			.expression {
				width: 24px;
				height: 24px;
				margin-right: 10px;
				cursor: pointer;
			}

			.more4 {
				width: 24px;
				height: 24px;
				cursor: pointer;
			}
		}

		.textareaContainer {
			// background: #F4F4F4;
			width: 100%;
			padding: 0 10px 10px 10px;
			border-radius: 0 0 10px 10px;
		}

		.emjoiContainer {
			.btn {
				width: 40px;
				height: 25px;
				background: #1e40af;
				border-radius: 5px;

				text-align: center;
				line-height: 25px;

				font-weight: 500;
				font-size: 14px;
				color: #ffffff;
				cursor: pointer;
			}
		}

		.submit {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: flex-end;

			.btn {
				width: 66px;
				height: 30px;
				background: #1e40af;
				border-radius: 5px;

				text-align: center;
				line-height: 30px;

				font-weight: 500;
				font-size: 14px;
				color: #ffffff;
				cursor: pointer;
			}
		}

		.close {
			position: absolute;
			top: -28px;
			right: -28px;
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
	}

	.ans-qws-wrap {
		padding: 20px 16px 0 16px;
		box-sizing: border-box;
		background: #f7f9ff;
		height: 410px;
		overflow-y: scroll;


		.school,
		.answer {
			position: relative;
			align-items: stretch;
			margin-bottom: 20px;

			.logo {
				width: 40px;
				height: 40px;
				background: #ffffff;
				padding: 2px;
				box-sizing: border-box;
				border-radius: 5px;
			}

			.logo-text {
				width: 40px;
				height: 40px;
				border-radius: 50%;
				background-color: blue;
				text-align: center;
				line-height: 40px;
				color: #ffffff;
				font-size: 16px;
				font-weight: 600;
				overflow: hidden;
			}

			.content {
				height: auto;
				border-radius: 5px;
				margin-left: 12px;
				position: relative;

				img {
					display: div;
					width: 100%;
				}

				.size-txt {
					padding-left: 10px;
					font-weight: 500;
					color: #999;
					font-size: 12px;
				}

				.issues-box {
					width: 426px;
					height: 264px;
					background: #ffffff;
					left: 16px;
					top: 110px;
					position: absolute;
					border-radius: 10px 10px 30px 30px;
				}

				.file-box {
					text {
						display: div;
					}

					.f-t-1 {
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}

					.f-t-2 {
						color: #999999;
						font-size: 12px;
						font-weight: 400;
						display: block;
						margin-top: 5px;
					}
				}
			}

			.txt {
				padding: 10px;
				font-size: 14px;
				line-height: 20px;
				font-weight: 500;
				color: #333;
				background: #ffffff;
				word-break: break-all;

				span {
					word-break: break-all;
					font-size: 16px;
					font-weight: 500;
					color: #222222;
					line-height: 24px;
				}

				.webs {
					color: #0572e2;
				}
			}

			.sanj {
				position: absolute;
				width: 0;
				height: 0;
				top: 10px;
				left: 32px;
				border: 12px solid transparent;
				border-right-color: #ffffff;
			}

			.sanj-img {
				position: absolute;
				width: 0;
				height: 0;
				top: 30px;
				left: 84px;
				border: 12px solid transparent;
				border-right-color: #fd8606;
			}
		}

		.answer {
			position: relative;

			.content {
				margin-right: 12px;
				margin-left: 0;
			}

			.map-box {
				width: 244px;
				height: 64px;
				background: #ffffff;
				border-top-left-radius: 6px;
				border-top-right-radius: 6px;
				padding: 10px 10px;
				box-sizing: border-box;

				span {
					display: block;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.tt1 {
					font-size: 14px;
					color: #222;
				}

				.tt2 {
					font-size: 12px;
					color: #c1c1c1;
				}
			}

			.content-school-box {
				width: 458px;
				height: auto;
				padding-bottom: 20px;
				box-sizing: border-box;

				.school-title {
					font-size: 30px;
					font-weight: bold;
					color: #333;
					margin-bottom: 20px;
				}

				.school-desc {
					margin-top: 10px;
					align-items: baseline;

					.l1 {
						width: 140px;
					}

					.l2 {
						font-size: 26px;
						font-weight: 500;
						color: #333;
					}

					.l3 {
						color: #0553f3;
					}
				}
			}

			.sanj {
				position: absolute;
				width: 0;
				height: 0;
				top: 10px;
				left: 322px;
				border: 12px solid transparent;
				border-left-color: #ffffff;
			}

			.sanj-img {
				position: absolute;
				width: 0;
				height: 0;
				top: 30px;
				left: 608px;
				border: 12px solid transparent;
				border-left-color: #fd8606;
			}
		}

		.wechat-box {
			width: 458px;
			height: 278px;
			background: #ffffff;
			border-radius: 16px;
			padding: 0;

			.title {
				width: 100%;
				height: 188px;
				line-height: 188px;
				text-align: center;
				font-size: 28px;
				font-weight: 500;
				color: #333;
			}

			.wechat-btn {
				border-top: 1px solid #f2f2f2;

				.wc {
					height: 90px;
					text-align: center;
					line-height: 90px;
					font-size: 28px;
					font-weight: 500;
					color: #333;
					line-height: 90px;
				}

				.wl {
					border-right: 1px solid #f2f2f2;
					color: #576b95;
				}
			}
		}
	}

	.content-box {
		padding: 0 20px;
		box-sizing: border-box;

		.job-item-box {
			width: 100%;
			min-height: 100px;
			height: auto;
			background: #fff;
			border-radius: 10px;
			margin-top: 20px;
			margin-bottom: 20px;
			padding: 10px 15px;
			box-sizing: border-box;

			.item-title {
				.left {
					font-size: 14px;
					font-weight: bold;
					color: #333333;
					width: auto;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
					flex: 1;
				}

				.ji {
					width: 60px;
					height: 30px;
					background: #ffffff;
					border: 1px solid #ff6600;
					border-radius: 5px;
					text-align: center;
					line-height: 30px;
					font-size: 14px;
					font-weight: 500;
					color: #ff6600;
					margin-left: 6px;
				}

				.right {
					font-size: 14px;
					font-weight: bold;
					color: #ff6600;
					text-align: right;
					white-space: nowrap;
				}
			}

			.company-name {
				// line-height: 30px;
				margin-top: 12px;

				.logo {
					width: 20px;
					height: 20px;
					border-radius: 50%;
					margin-right: 4px;
					color: #fff;
					text-align: center;
					font-size: 20px;
					line-height: 30px;
				}

				.logo-text {
					background-color: blue;
				}

				span {
					font-size: 14px;
					font-weight: 400;
					color: #999;
					width: 320px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}

			.item-block {
				justify-content: flex-start;
				margin-top: 10px;

				span {
					height: 22px;
					background: #f7f7f7;
					border-radius: 5px;
					padding: 0 10px;
					font-size: 12px;
					font-weight: 500;
					color: #5f5f5f;
					margin-right: 12px;
					line-height: 22px;
				}
			}
		}
	}

	.logo-text {
		width: 80px;
		height: 80px;
		border-radius: 50%;
		background-color: blue;
		text-align: center;
		line-height: 80px;
		color: #ffffff;
		font-size: 28px;
		font-weight: 600;
		overflow: hidden;
	}

	.audio-facade {
		min-width: 20px;
		font-size: 14px;
		border-radius: 14px;
		color: #000000;
		display: flex;
		cursor: pointer;
	}

	.audio-facade-bg {
		background: url('https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/04/11/x1vp00gsvfjuhndc.png') no-repeat center;
		background-size: 20px;
		width: 40px;
	}

	.audio-facade-bg.play-icon {
		background: url('https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2025/04/11/zkiwrpfrrwwjr8jz.gif') no-repeat center;
		background-size: 30px;
	}

	.expression-scrool {
		height: 160px;
		background: #f6f6f6;

		.expression-box {
			height: 160px;
			padding: 20px 7px;
			box-sizing: border-box;
			flex-wrap: wrap;
			justify-content: flex-start;

			.item {
				width: 92px;
				font-size: 56px;
				line-height: 92px;
				height: 92px;
				text-align: center;
			}
		}

		.send-box {
			// margin-top: 50px;
			// padding-top: 30px;
			justify-content: space-between;
			padding: 20px 50px;
			box-sizing: border-box;

			.item {
				width: 80px;

				img {
					width: 80px;
					height: 80px;
					display: block;
				}

				span {
					display: block;
					text-align: center;
					font-size: 14px;
					color: #616161;
					margin-top: 6px;
				}
			}
		}
	}

	.avatar-uploader1 .avatar-uploader1 .el-upload {
		border: none;
	}

	.companyInfo {
		width: 100%;
		padding: 20px 0 20px 0;
		border-bottom: 1px solid #eeeeee;
		font-size: 0;
		display: flex;
		align-items: center;
		margin-bottom: 15px;

		// img {
		// 	width: 57px;
		// 	height: 57px;
		// 	border-radius: 50%;
		// 	background: #003987;
		// 	margin-right: 10px;
		// }

		.companyInfoRight {
			display: flex;
			justify-content: center;
			flex-direction: column;

			.companyInfoName {
				font-weight: 500;
				font-size: 18px;
				color: #2d3c50;
				margin-bottom: 10px;
			}

			.tags {
				display: flex;
				align-items: center;

				.item {
					padding: 2px 4px;
					border-radius: 5px;
					border: 1px solid #aeaeae;
					font-weight: 500;
					font-size: 12px;
					color: #aeaeae;
					margin-right: 5px;
				}
			}
		}
	}

	.img-carousel-box {
		width: 100%;
		height: 650px;

		img {
			display: block;
			max-width: 100%;
			margin: 0 auto;
			height: 600px;
		}
	}

	.paging {
		width: 100%;
		padding: 20px 40px;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.pagingLeft {
			display: flex;
			align-items: center;
		}
	}


	.revocation {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-bottom: 20px;
		padding-top: 3px;
		padding-right: 52px;

		.item {
			border-radius: 5px;
			background: #f7f9ff;
			padding: 4px;
			font-size: 0;
			cursor: pointer;

			img {
				width: 16px;
				height: 16px;
			}
		}

		.item:hover {
			background: #ccc;
		}

	}

	@media (max-width: 1599px) {
		.list {
			grid-template-columns: repeat(3, 1fr);
		}
	}

	@media (min-width: 1599px) {
		.list {
			grid-template-columns: repeat(4, 1fr);
		}
	}

	.resume-fly-card {
			position: fixed;
			z-index: 9999;
			width: 60px;
			height: 60px;
			padding: 6px;
			box-sizing: border-box;
			border-radius: 14px;
			background: #fff;
			pointer-events: none;
			will-change: transform, left, top, opacity;
	}

	.resumeDatabase {
		.list {
			min-width: 1110px;
			// display: flex;
			// align-items: center;
			// flex-wrap: wrap;
			// justify-content: space-between;

			display: grid;
			// grid-template-columns: repeat(3, 1fr);

			grid-gap: 10px 10px;
			align-content: start;

			.item {
				min-width: 335px;
				max-width: 542px;
				height: 210px;
				flex: 1;
				background: #FFFFFF;
				border-radius: 10px;
				padding: 15px 15px;
				display: flex;
				justify-content: space-between;
				flex-direction: column;
				// height: 281px;
				// margin: 0 10px 10px 0;

				.studentInfo {
					display: flex;
					align-items: center;
					// justify-content: space-between;
					margin-bottom: 10px;

					.left {
						flex: 1;

						.nameContainer {
							// display: flex;
							// align-items: center;
							// margin-bottom: 15px;

							.name {
								font-weight: bold;
								font-size: 16px;
								color: #000000;
								margin-right: 10px;
								// margin-bottom: 5px;
							}

							.other {
								font-weight: 400;
								font-size: 14px;
								color: #6B7280;
							}
						}


					}

					.right {
						font-size: 0;
						margin-right: 10px;

						img {
							width: 55px;
							height: 55px;
							border-radius: 50%;
							// background: #003987;
						}
					}
				}

				.education {
					width: 100%;
					font-weight: bold;
					font-size: 14px;
					color: #333;
					// margin-bottom: 5px;
				}

				.intentionContainer {
					margin-bottom: 5px;

					.intentionitem {
						display: flex;
						align-items: center;
						font-size: 0;

						img {
							width: 15px;
							height: 15px;
							margin-right: 5px;
							// margin-top: 2px;
						}

						div {
							font-weight: 500;
							font-size: 14px;
							color: #5a6374;
						}
					}
				}

				.skillTag {
					display: flex;
					align-items: center;
					margin-bottom: 10px;

					.tagItem {
						padding: 2px 7px;
						border-radius: 5px;
						font-weight: 500;
						font-size: 14px;
						color: #000;
						margin-right: 10px;
						background: #F3F4F6;
					}
				}

				.briefIntroduction {
					// display: flex;
					align-items: center;
					margin-bottom: 10px;
					padding-bottom: 10px;

					.briefIntroductionLeft {
						flex: 1;
						// margin-right: 30px;
						font-weight: 500;
						font-size: 14px;
						color: #5a6374;
						// line-height: 22px;
						// height: 45px;
						// padding-bottom: 10px;
					}


				}

				.briefIntroductionRight {
					background: #1E40AF;
					border-radius: 5px;
					width: 100%;
					height: 39px;
					text-align: center;
					line-height: 39px;
					font-weight: 500;
					font-size: 14px;
					color: #FFFFFF;

				}

				.btnContainer {
					display: flex;
					align-items: center;
					justify-content: space-between;

					.item {
						display: flex;
						align-items: center;

						.img {}
					}
				}

			}
		}

		.paging {
			width: 100%;
			padding: 20px 0;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.pagingLeft {
				display: flex;
				align-items: center;

			}
		}
	}

	.homeList .item:hover {
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
		transform: translateY(-2px);
		transition: .2s all;
	}
	.homeList{
		min-height:698px;
	}
	.resume-filter-panel {
		box-sizing: border-box;
		align-items: flex-start;
		gap: 28px;
		padding: 0 28px 18px !important;
		margin: 0 0 12px;
		background: #fff;
		border-radius: 0 0 10px 10px;
        min-width:1150px;
	}

	.resume-page-refresh {
		// margin-left: 16px;
		font-size: 14px;
		color: #606266;
		cursor: pointer;
	}

	.resume-page-refresh i { margin-left: 0; }
	.resume-page-refresh.is-refreshing i { animation: resume-page-refresh-loading .8s linear infinite; }

	@keyframes resume-page-refresh-loading {
		from { transform: rotate(0deg); }
		to { transform: rotate(360deg); }
	}

	.resume-filter-options {
		flex: 1;
		min-width: 0;
		// padding: 16px 20px;
		// border: 1px solid #ebeef5;
		border-radius: 10px;
		box-sizing: border-box;
	}

	.resume-filter-panel .stateContainer {
		margin-bottom: 12px !important;
	}

	.resume-filter-panel .stateContainer:last-child {
		margin-bottom: 0 !important;
	}

	.resume-filter-tools {
		width: 450px;
		flex: 0 0 450px;
        margin-top:-38px;
	}

	.resume-quota-panel {
		display: flex;
		align-items: center;
		height: 50px;
		margin-bottom: 16px;
		border-radius: 10px;
		// background: #f3f6fb;
		overflow: hidden;
	}

	.resume-quota-item {
		flex: 1;
		min-width: 0;
		text-align: center;
		font-size: 13px;
		color: #1f2937;
		line-height: 20px;
        height: 55px;
        padding-top:8px;box-sizing:border-box;
		// border-right: 1px solid #dfe5ef;
        background: #f3f6fb;
	}
    .resume-quota-item:nth-of-type(1){
        border-top-left-radius:10px;
         border-bottom-left-radius:10px;
         position: relative;
         &::after{
             width:1px;
             height:26px;
             right:0;
             top:15px;
             position: absolute;
             content:"";
             background:#dfe5ef;
         }
    }
    
    .resume-quota-item:nth-of-type(3){
        border-top-right-radius:10px;
         border-bottom-right-radius:10px;
         position: relative;
         &::after{
             width:1px;
              height:26px;
             left:0;
             top:15px;
             position: absolute;
             content:"";
             background:#dfe5ef;
         }
    }
	.resume-quota-item span,
	.resume-quota-item strong,
	.resume-quota-item em {
		display: block;
		font-style: normal;
	}

	.resume-quota-item strong {
		display: inline;
		font-size: 16px;
		font-weight: 600;
		color: #1677ff;
	}

	.resume-quota-item em {
		display: inline;
		font-size: 10px;
		color: #6b7280;
	}

	.resume-download-button {
		align-self: stretch;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100px;
		margin-left: 10px;
		background: #1677ff;
		font-size: 14px;
		color: #fff;
		cursor: pointer;
        border-radius:10px;
        // border-left:10px solid #ffffff;
	}

	.resume-download-button i { margin-left: 5px; font-size: 16px; }
	.resume-download-button i.is-downloading { animation: resume-download-loading .8s linear infinite; }

	@keyframes resume-download-loading {
		from { transform: rotate(0deg); }
		to { transform: rotate(360deg); }
	}

	.resume-search {
		height: 40px;
		border-radius: 4px;
		background: #f3f6fb;
	}

	.resume-search input { flex: 1; background: transparent; }

	.resume-library-content {
		padding: 12px 10px 18px !important;
		background: #f3f6fb !important;
	}

	.resumeDatabase .list .resume-card {
		position: relative;
		height: 226px;
		max-width: none;
		padding: 20px 26px 54px;
		border-radius: 10px;
		box-sizing: border-box;
	}

	.resumeDatabase .list .resume-card .studentInfo { margin-bottom: 10px; }
	.resumeDatabase .list .resume-card .education { margin-bottom: 8px !important; }
	.resumeDatabase .list .resume-card .intentionContainer { margin-bottom: 8px; }
	.resumeDatabase .list .resume-card .briefIntroduction {
		margin-bottom: 0;
		padding-bottom: 8px;
		border-bottom: 0 !important;
	}

	.resume-card .resume-status {
		display: flex;
		align-items: center;
		font-size: 14px;
		white-space: nowrap;
	}

	.resume-card .resume-status i { margin-right: 4px; font-size: 18px; }
	.resume-status-1 { color: #7b8493; }
	.resume-status-2 { color: #ff5a36; }
	.resume-status-3 { color: #5c5c5c; }
	.resume-status-4 { color: #1677ff; }

	.resume-card .resume-legacy-actions,
	.resume-card > .btnContainer { display: none !important; }

	.resume-card .resume-preview-action {
		position: absolute;
		left: 26px;
		right: 26px;
		bottom: 14px;
		height: 36px;
		border-radius: 4px;
		background: #e1f0ff;
		font-size: 14px;
		line-height: 36px;
		text-align: center;
		color: #1677ff;
		cursor: pointer;
	}

	.resume-card .resume-preview-action:hover { background: #cfe7ff; }
	
	
	
	.search{
		display: flex;
		align-items: center;
		background: #f0f4fa;
		border-radius: 5px;
		height: 40px;
		padding: 0 10px;
		img{
			width: 20px;
			height: 20px;
			margin-right: 10px;
		}
		input{
			margin-right: 10px;
			outline: none;
			background:#f0f4fa;
			font-size: 14px;
			border: none;
			margin-right: 10px;
		}
		div{
			color: #1e40af;
			font-weight: bold;
			font-size: 14px;
		}
	}
    .stateContainerx1{
		display: flex;
		align-items: center;
        justify-content: flex-start;
        flex-wrap: nowrap;
		white-space: nowrap;
		& + & {
			// margin-top: 12px !important;
			// padding-top: 12px;
			// border-top: 1px solid #ebeef5;
		}
		.job-tags{
			display: flex;
			flex: none;
			overflow: hidden;
		}
        .title{
				flex: 0 0 auto;
				font-weight: 600;
                font-size: 14px;
				color: #303133;
        }
        .tags1{
			display: inline-flex;
			align-items: center;
			justify-content: center;
			height: 26px;
			padding: 0 12px;
            font-size: 14px;
			margin-left: 8px;
            font-weight:400;
			color: #606266;
			border-radius: 17px;
			box-sizing: border-box;
			cursor: pointer;
			transition: background-color .2s, color .2s;
			&.is-active {
				background: #e8f3ff;
				color: #1677ff;
				font-weight: 600;
				span{
					background:#ffffff;
					border-radius: 10px;
					padding: 0 3px;
				}
			}
        }
		.job-more{
			display: flex;
			align-items: center;
			max-width: 150px;
			margin-left: 8px;
			padding: 8px 4px;
			font-size: 14px;
			color: #606266;
			cursor: pointer;
			& span {
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
			&.is-active { color: #1677ff; font-weight: 600; }
		}
        .tags2{
			flex: 0 0 auto;
			max-width: 150px;
			overflow: hidden;
			text-overflow: ellipsis;
            margin-right: 0;
        }
		.status-tag {
			gap: 6px;
			& span {
				font-size: 13px;
				color: #909399;
			}
			&.is-active {
				background: #fdefef;
				color: #c03636;
				& span { color: #c03636; }
			}
		}
		.filter-reset {
			flex: 0 0 auto;
			margin-left: 16px;
			padding: 8px 0;
			font-size: 14px;
			color: #606266;
			cursor: pointer;
			&:hover { color: #1677ff; }
		}
    }

	.job-more-list > div {
		max-width: 240px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		cursor: pointer;
	}

	.job-more-list > div.is-active { color: #1677ff; font-weight: 600; }
</style>
